// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.6.1
//   protoc               unknown
// source: models/models.proto

/* eslint-disable */
import { BinaryReader, BinaryWriter } from "@bufbuild/protobuf/wire";
import {
  ConfigOrigin,
  configOriginFromJSON,
  configOriginToJSON,
  ConfigType,
  configTypeFromJSON,
  configTypeToJSON,
  ConnectedState,
  connectedStateFromJSON,
  connectedStateToJSON,
  FabricTopology,
  fabricTopologyFromJSON,
  fabricTopologyToJSON,
  LacpMode,
  lacpModeFromJSON,
  lacpModeToJSON,
  NodeRole,
  nodeRoleFromJSON,
  nodeRoleToJSON,
  NodeType,
  nodeTypeFromJSON,
  nodeTypeToJSON,
  PortRole,
  portRoleFromJSON,
  portRoleToJSON,
  PortType,
  portTypeFromJSON,
  portTypeToJSON,
  RouteTag,
  routeTagFromJSON,
  routeTagToJSON,
  ServerPortGroupType,
  serverPortGroupTypeFromJSON,
  serverPortGroupTypeToJSON,
} from "./fabric";
import { FabricDesign } from "./fabric_design";
import {
  Annotation,
  EntitlementLevel,
  entitlementLevelFromJSON,
  entitlementLevelToJSON,
  FabricType,
  fabricTypeFromJSON,
  fabricTypeToJSON,
  OsType,
  osTypeFromJSON,
  osTypeToJSON,
} from "./global";
import {
  InterfaceStp,
  Metadata,
  NetworkInterface,
  PortConnection,
  PortEndpoint,
  PsuAirflow,
  RouteInfo,
  Svi,
  VlanMember,
  VniDhcp,
} from "./types";

export const protobufPackage = "models";

/**
 * A Port encapsulates the configuration and properties of a front panel network interface of
 * a node used as fabric port to interconnect with other nodes, as routed port to peer at
 * Layer 3 with external devices, as Link Aggregation Group member or as a host port to connect
 * to other endpoints via Layer 2 (VLAN).
 *
 * INTERNAL
 *
 * NetworkPort encapsulates properties of a physical network port.
 *
 * NetworkPort is always on a Linecard. Each Linecard may contain dozens of ports.
 * A Node may have multiple linecards. Port name uniquely identifies a port within a node.
 * Port name is in the following format:
 *    Ethernet{{ Linecard }}_{{ Index }}_{{ Breakout index }}
 *
 * A NetworkPort maybe broken out into multiple NetworkPort objects. This is desirable
 * when NetworkPort has high bandwidth, and attached hosts have interfaces with lower
 * bandwidth. For example, a 400Gbps NetworkPort maybe broken out into four 100Gbps
 * NetworkPort objects. When a network port is in break-out mode, then there can be many
 * NetworkPort objects with the same Index. For example, following NetworkPort objects are
 * in break-out mode on port index 1.
 * E.g.:
 *    Ethernet1_1_1: Index = 1, Breakout = 1
 *    Ethernet1_1_4: Index = 1, Breakout = 4
 *    Ethernet1_2_2: Index = 2, Breakout = 2
 */
export interface NetworkPort {
  /**
   * The unique identifier of the port.
   *
   * INTERNAL
   *
   * The unique identifier of NetworkPort. Identifier is required to update an existing
   * NetworkPort. If identifier is missing, then set operation defaults to CREATE mode.
   */
  id: string;
  /**
   * The name of the port of the node.
   * The name must have a prefix of Ethernet (E.g. Ethernet1_1) and cannot be modified.
   *
   * INTERNAL
   *
   * The canonical name of NetworkPort. Name must have a prefix of Ethernet (E.g. Ethernet1_1).
   * NetworkPort name cannot be modified.
   */
  name: string;
  /**
   * The unique identifier of the node to which this port belongs to.
   *
   * INTERNAL
   *
   * The identifier of the Node that owns the NetworkPort. NodeId is readonly, and cannot be modified.
   */
  nodeId: string;
  /** The description is a user-defined field to store notes about the port. */
  description: string;
  /** A list of user-defined labels that can be used for grouping and filtering ports. */
  labels: string[];
  /**
   * A list of name-value annotations to store user-defined data including complex data such as JSON
   * associated with the port.
   */
  annotations: Annotation[];
  /** The enabled state of the port which indicates if the port is enabled or disabled. */
  enabled: boolean;
  /** A map of attributes related to the lifecycle of the port. */
  metadata:
    | Metadata
    | undefined;
  /**
   * The index number of the port on the linecard.
   *
   * INTERNAL
   *
   * Port index is one based. Index remains same for all NetworkPort objects in break-out mode.
   * Index is readonly.
   */
  index: number;
  /**
   * The flag that indicates if the port is in breakout mode or not.
   *
   * INTERNAL
   *
   * Breakout flag is readonly.
   */
  breakout: boolean;
  /**
   * The index number of the breakout in the parent port. The breakout index is not set when the port
   * is not in breakout mode.
   *
   * INTERNAL
   *
   * Breakout index is readonly.
   */
  breakoutIndex: number;
  /**
   * The index number of the linecard to which this port belongs to.
   *
   * INTERNAL
   *
   * Linecard is readonly.
   */
  linecard: number;
  /**
   * The unique identifier of the VRF associated with the port. The VRF identifier is required
   * for a port with the `ROUTED_PORT` role.
   */
  vrfId: string;
  /**
   * A list of VLAN IDs deployed on the port of the node.
   *
   * INTERNAL
   *
   * VlanIds is readonly. VlanIds is set by GetNodesPorts API.
   */
  vlanIds: number[];
  /**
   * A list of VNIs attached to the port of the node.
   *
   * INTERNAL
   *
   * Vnis is readonly. Vnis is set by GetNodesPorts API.
   */
  vnis: number[];
  /**
   * The Forward Error Correction (FEC) mode of the port. Supported modes are "rs" and "none".
   * The FEC must be set to "none" for 100G DR/FR/LR pluggable optics.
   */
  fec: string;
  /**
   * A list of roles of the port. The port roles list is mandatory, and must contain
   * exactly one role.
   */
  roles: PortRole[];
  /**
   * Prevent traffic from being forwarded by the port. Requires `enabled` to be set to `true`
   * (equivalent to `Admin State` set to `Up`) and role to be one of `UNUSED_PORT`, `ROUTED_PORT`
   * or `HOST_PORT`.
   *
   * INTERNAL
   *
   * Indicates that port is in link-down state. In this mode, AdminState is UP,
   * however, port may not forward any traffic to external hosts. LinkDown state
   * is not supported for Fabric ports.
   */
  linkDown: boolean;
  /**
   * A list of up to two IPv4 host addresses with subnet mask to be configured on the port.
   * Requires the `ROUTED_PORT` role to be configured in roles and the port to be associated
   * with a VRF.
   *
   * INTERNAL
   *
   * Meaning, address must be in CIDR format with CIDR < 32.
   */
  ipv4Addresses: string[];
  /**
   * A list of up to two IPv6 host addresses with subnet mask to be configured on the port.
   * Requires the `ROUTED_PORT` role to be configured in roles and the port to be associated
   * with a VRF.
   *
   * INTERNAL
   *
   * Meaning, address must be in CIDR format with CIDR < 128.
   */
  ipv6Addresses: string[];
  /**
   * The number of sub-interfaces configured on the port.
   *
   * INTERNAL
   *
   * This property is readonly.
   */
  subInfCount: number;
  /**
   * The Spanning Tree Protocol (STP) configuration for the port. The configuration is only
   * used when a VLAN is deployed on the port.
   */
  stp:
    | InterfaceStp
    | undefined;
  /**
   * The tag to be used for IP addresses in the same subnet as the port.
   * RouteTag is meaningful only for routed port.
   */
  tag: RouteTag;
  /** The type or name of the model (PID) of the pluggable cable or optic expected to be used in the port. */
  pluggable: string;
  /**
   * The Maximum Transmission Unit (MTU) of the port of the node. Default value is 9216 for
   * "FABRIC_PORT" and 9100 for all other roles. The MTU value must be 9216 for "FABRIC_PORT"
   * and between 1500 and 9100 for all other roles.
   */
  mtu: number;
  /**
   * The maximum speed of the port as reported by the system (E.g. 10G).
   *
   * INTERNAL
   *
   * This property is readonly.
   */
  maxSpeed: string;
  /**
   * The configurable speed mode of the port (E.g. 1x100G). The port speed cannot be set
   * for a port in breakout mode.
   */
  speed: string;
  /**
   * The Force Counter can be incremented to force the port configuration to be forcefully
   * reapplied when there are no other configuration changes such as to recover (un-shut)
   * a port blocked by STP.
   *
   * INTERNAL
   *
   * User may increment ForceCounter to re-apply port config without changing any other
   * properties. This is useful to recover port (un-shut) port blocked by STP.
   */
  forceCounter: number;
  /**
   * The name alias of the port.
   *
   * INTERNAL
   *
   * This specifies the alias for the port. The name of the port is always in canonical form
   * but in the server case, this would also indicate the ensXXX alias for the port.
   */
  portAlias: string;
}

/**
 * A management port encapsulates the configuration and properties of an Out of Band network
 * interface of a node used to communicate with the Cisco Nexus Hyperfabric service.
 */
export interface ManagementPort {
  /**
   * The unique identifier of the management port.
   *
   * INTERNAL
   *
   * Identifier is required to update an existing ManagementPort.
   * If not provided, then assume the port is to be created.
   */
  id: string;
  /**
   * The unique identifier of the node to which this management port belongs to.
   *
   * INTERNAL
   *
   * NodeId is readonly, and cannot be modified.
   */
  nodeId: string;
  /**
   * The name of the management port of the node (E.g. eth0).
   *
   * INTERNAL
   *
   * This is a read-only attribute.
   */
  name: string;
  /**
   * The description is a user-defined field to store notes about the management port.
   *
   * INTERNAL
   *
   * This is a read-only attribute.
   */
  description: string;
  /** The IPv4 host address for the management port of the node. */
  ipv4Address: string;
  /** The IPv4 gateway address for the management port of the node. */
  ipv4Gateway: string;
  /** The IPv6 host address for the management port of the node. */
  ipv6Address: string;
  /** The IPv6 gateway address for the management port of the node. */
  ipv6Gateway: string;
  /** A list of one or more DNS IP addresses used by the node. */
  dnsAddresses: string[];
  /** The URL for a configured HTTPs proxy for the node. */
  proxyAddress: string;
  /** A username to be used to authenticate to the proxy. */
  proxyUsername: string;
  /** A unique identifier of a set of credentials for the proxy. */
  proxyCredentialsId: string;
  /**
   * A password to be used to authenticate to the proxy. Once set, this attribute is not
   * returned.
   */
  proxyPassword: string;
  /**
   * The administrative state of the management port which indicates if the management port
   * is enabled or disabled.
   */
  enabled: boolean;
  /**
   * The connected state denoting if the management port is successfully connected to the
   * Hyperfabric service.
   */
  connectedState: ConnectedState;
  /** Determines if the IPv4 configuration is static or from DHCP */
  ipv4ConfigType: ConfigType;
  /** Determines if the IPv6 configuration is static or from DHCP */
  ipv6ConfigType: ConfigType;
  /** A list of NTP Server IP addresses used by a node. */
  ntpAddresses: string[];
  /** A list of one or more Cloud URLs used by a node. */
  cloudUrls: string[];
  /**
   * The source of the configuration, either from the cloud or the device.
   *
   * INTERNAL
   *
   * This is a read-only attribute.
   */
  configOrigin: ConfigOrigin;
  /** A map of attributes related to the lifecycle of the management port. */
  metadata:
    | Metadata
    | undefined;
  /**
   * The flag to indicate that the proxy password should be cleared.
   *
   * INTERNAL
   *
   * The unencrypted password is not returned to the caller and this is used to differentiate
   * between clearing the password and not changing it.
   */
  setProxyPassword: boolean;
  /**
   * The password to be used by the system user to login to the node. An empty password
   * is treated as "use current password", and not as "no password".
   */
  loginPassword: string;
  /** A list of IP addresses or domain names that should not be proxied. */
  noProxy: string[];
  /** The type of the management port of the node. */
  portType: PortType;
}

export interface ServerMgmtPort {
  /**
   * The unique identifier of the Server MGMT port(BMC or LOM port).
   *
   * INTERNAL
   *
   * Identifier is required to update an existing server mgmt Port.
   * If not provided, then assume the port is to be created.
   */
  id: string;
  /**
   * The unique identifier of the node to which this server mgmt port belongs to.
   *
   * INTERNAL
   *
   * NodeId is readonly, and cannot be modified.
   */
  nodeId: string;
  /**
   * The name of the server mgmt port of the node (E.g. eth0)
   *
   * INTERNAL
   *
   * This is a read-only attribute.
   */
  name: string;
  /**
   * The description is a user-defined field to store notes about the server mgmt port.
   *
   * INTERNAL
   *
   * This is a read-only attribute.
   */
  description: string;
  /**
   * The index number of the linecard to which this port belongs to.
   *
   * INTERNAL
   *
   * Linecard is readonly.
   */
  linecard: number;
  index: number;
  portType: PortType;
  portGroupType: ServerPortGroupType;
  /** Mac address of the server mgmt port */
  macAddress: string;
  pluggable: string;
  speed: string;
  remoteNodeId: string;
  /** The remote port name that connects to this server mgmt port */
  remotePort: string;
  remotePluggable: string;
  cablePid: string;
  credentialsId: string;
  ipv4Address: string;
  ipv6Address: string;
}

/** BmcNtpConfig encapsulates desired NTP settings for a server BMC endpoint. */
export interface BmcNtpConfig {
  /** Indicates whether BMC NTP is enabled. */
  enabled: boolean;
  /**
   * A list of up to four NTP servers, specified as fully qualified domain names
   * (FQDNs), IPv4 addresses, or IPv6 addresses.
   */
  servers: string[];
}

/**
 * BmcConfig encapsulates desired configuration for a server BMC endpoint.
 * The target endpoint is identified by node, server port group, and slot.
 */
export interface BmcConfig {
  /** The unique identifier of BmcConfig. If omitted, the operation creates a new object. */
  id: string;
  /** The user-defined name of BmcConfig. */
  name: string;
  /** A user-defined description of BmcConfig. */
  description: string;
  /** User-defined labels associated with BmcConfig. */
  labels: string[];
  /** User-defined annotations associated with BmcConfig. */
  annotations: Annotation[];
  /** Indicates whether this desired configuration is enabled. */
  enabled: boolean;
  /** Read-only revision metadata of BmcConfig. */
  metadata:
    | Metadata
    | undefined;
  /** The fabric containing the target node. */
  fabricId: string;
  /** The node containing the target BMC endpoint. */
  nodeId: string;
  /** The BMC server-port group containing the target endpoint. */
  portGroupType: ServerPortGroupType;
  /** The slot number within port_group_type. */
  slotNumber: number;
  /** Desired NTP settings. */
  ntp: BmcNtpConfig | undefined;
}

/**
 * A Port Channel encapsulates the configuration and properties of a set of front panel network interface
 * of one or more nodes grouped in a LACP bundle used as a host port to connect to other endpoints via
 * Layer 2 (VLAN).
 *
 * INTERNAL
 *
 * PortChannel represents a set of physical ports in a PortChannel/LACP config.
 * PortChannel name is unique within a fabric.
 * NOTES:
 * - PortChannel object must have HOST_PORT as role.
 * - PortChannel members cannot be part of Vlans.
 * - PortChannel member ports must have LAG_PORT as port role.
 */
export interface PortChannel {
  /**
   * The unique identifier of the port channel.
   *
   * INTERNAL
   *
   * The unique identifier of PortChannel. Identifier is required to update an existing
   * PortChannel. If identifier is missing, then set operation defaults to CREATE mode.
   */
  id: string;
  /** The name of the port channel. Name must have a prefix of PortChannel (E.g. PortChannel1). */
  name: string;
  /** The description is a user-defined field to store notes about the port channel. */
  description: string;
  /** A list of user-defined labels that can be used for grouping and filtering port channels. */
  labels: string[];
  /**
   * A list of name-value annotations to store user-defined data including complex data such as JSON
   * associated with the port channel.
   */
  annotations: Annotation[];
  /** The enabled state of the port channel which indicates if the port channel is enabled or disabled. */
  enabled: boolean;
  /** A map of attributes related to the lifecycle of the port channel. */
  metadata:
    | Metadata
    | undefined;
  /**
   * The unique identifier of the fabric to which this port channel belongs to.
   *
   * INTERNAL
   *
   * The identifier of the fabric to which this port channel belongs to. FabricId is mandatory.
   */
  fabricId: string;
  /**
   * A list of roles of the port channel. The port roles list is mandatory, must contain
   * exactly one role, and it must be "HOST_PORT".
   */
  roles: PortRole[];
  /**
   * A set of ports (E.g. Ethernet1_1, Ethernet1_4 etc.) of one or more nodes to be grouped in a LACP bundle.
   *
   * INTERNAL
   *
   * There must be at least two members.
   */
  members: PortEndpoint[];
  /** The LACP mode used by the port channel. */
  lacpMode: LacpMode;
  /**
   * The Maximum Transmission Unit (MTU) of the port channel. Default value is 9100.
   * The MTU value must be between 1500 and 9100.
   */
  mtu: number;
  /** The minimum number of active links needed for the port channel to operate. */
  minLinks: number;
  /**
   * A list of up to two IPv4 host addresses with subnet mask to be configured on the port channel.
   *
   * INTERNAL
   *
   * IPv4 address is valid only for routed PortChannel.
   */
  ipv4Addresses: string[];
  /**
   * A list of up to two IPv6 host addresses with subnet mask to be configured on the port channel.
   *
   * INTERNAL
   *
   * IPv6 address is valid only for routed PortChannel.
   */
  ipv6Addresses: string[];
  /** MAC address used for EVPN multi-homing. */
  sysMac: string;
  /**
   * The Spanning Tree Protocol (STP) configuration for the port channel. The configuration is only
   * used when a VLAN is deployed on the port channel.
   *
   * INTERNAL
   *
   * Note that STP is supported only when PortChannel is un LAG mode.
   */
  stp:
    | InterfaceStp
    | undefined;
  /**
   * The unique identifier of the VRF associated with the port channel. The VRF identifier is required
   * for a port channel with the `ROUTED_PORT` role.
   */
  vrfId: string;
  /**
   * A list of VLAN IDs deployed on the port channel.
   *
   * INTERNAL
   *
   * VlanIds defines the identifiers of VLANs of which this port channel is a member of.
   * VlanIds is readonly.
   */
  vlanIds: number[];
  /**
   * A list of VNIs attached to the port channel.
   *
   * INTERNAL
   *
   * Vnis defines the identifiers of VNIs of which this port channel is a member of.
   * Vnis is readonly.
   */
  vnis: number[];
  /** The maximum speed of the port channel (E.g. 100G). */
  maxSpeed: string;
}

/**
 * A dot1q VLAN Sub-Interface is a virtual network interface that is associated with a VLAN ID
 * on a routed front panel network interface of a Node used as source interface to peer at Layer 3 with
 * external devices. The parent interface of a Sub-Interface is a Node Port with the
 * `UNUSED_PORT` or `ROUTED_PORT` role.
 *
 * INTERNAL
 *
 * SubInterface encapsulates properties of a sub-port or sub-interface. SubInterface provides
 * logical division of a physical interface. SubInterface cannot be added to a NetworkPort or
 * a PortChannel attached to Vlans. SubInterface maybe added a routed port or routed PortChannel.
 */
export interface SubInterface {
  /**
   * The unique identifier of the sub-interface.
   *
   * INTERNAL
   *
   * Identifier is required to update an existing
   * SubInterface. If identifier is missing, then set operation defaults to CREATE mode.
   */
  id: string;
  /**
   * The name of the sub-interface of the node. Must be in the format Ethernet1_1_1.\<VLAN_ID\>.
   *
   * INTERNAL
   *
   * The user-defined name of the SubInterface. SubInterface name is unique, and must be
   * in the format (<Ethernet1_4_1|<PortChannel0>)[.]<ID>
   */
  name: string;
  /** The description is a user-defined field to store notes about the sub-interface. */
  description: string;
  /** A list of user-defined labels that can be used for grouping and filtering sub-interfaces. */
  labels: string[];
  /**
   * A list of name-value annotations to store user-defined data including complex data such as JSON
   * associated with the sub-interface.
   */
  annotations: Annotation[];
  /** The enabled state of the sub-interface which indicates if the sub-interface is enabled or disabled. */
  enabled: boolean;
  /** A map of attributes related to the lifecycle of the sub-interface. */
  metadata:
    | Metadata
    | undefined;
  /**
   * The unique identifier of the fabric to which this sub-interface belongs to.
   *
   * INTERNAL
   *
   * The identifier of Fabric to which this SubInterface belongs to. FabricId is mandatory.
   */
  fabricId: string;
  /**
   * The unique identifier of the node to which this sub-interface belongs to.
   *
   * INTERNAL
   *
   * The identifier of the Node where SubInterface is located. NodeId is mandatory.
   */
  nodeId: string;
  /**
   * The VLAN ID used as dot1q encapsulation for the sub-interface. The VLAN ID must be between 1 and 4094.
   *
   * INTERNAL
   *
   * Vlan identifier of SubInterface.
   */
  vlanId: number;
  /**
   * The unique identifier of the VRF to which this sub-interface is attached to.
   *
   * INTERNAL
   *
   * The identifier of VRF to which this SubInterface belongs to.
   */
  vrfId: string;
  /**
   * The name of parent interface to which this sub-interface belong to.
   *
   * INTERNAL
   *
   * This property is readonly.
   */
  parent: string;
  /**
   * A list of up to two IPv4 host addresses with subnet mask to be configured on the sub-interface.
   *
   * INTERNAL
   *
   * Meaning, address must be in CIDR format with CIDR < 32.
   */
  ipv4Addresses: string[];
  /**
   * A list of up to two IPv6 host addresses with subnet mask to be configured on the sub-interface.
   *
   * INTERNAL
   *
   * Meaning, address must be in CIDR format with CIDR < 128.
   */
  ipv6Addresses: string[];
  /** The tag to be used for IP addresses in the same subnet as the sub-interface. */
  tag: RouteTag;
}

/**
 * Node encapsulates properties of a blueprint fabric node. A node has
 * the following properties and child objects.
 *  - roles: A set of roles that defines what the node is for.
 *  - ports: Physical ports of node. If a port is in break-out mode,
 *    then the break-out ports are treated as physical ports of the node.
 *  - routerId: The service allocated router identifier meant for BGP sessions.
 */
export interface Node {
  /**
   * The unique identifier of the Node. Identifier is required to update an existing
   * node. If identifier is missing, then set operation defaults to CREATE mode.
   */
  id: string;
  /**
   * The user-defined name of the Node. Node name is unique, and must be a FQDN
   * compliant, single label hostname.
   */
  name: string;
  /** A user-defined description of the node. */
  description: string;
  /** A list of user-defined labels that can be used for grouping and filtering nodes. */
  labels: string[];
  /**
   * A list of name-value annotations to store user-defined data including complex data such as JSON
   * associated with the node.
   */
  annotations: Annotation[];
  /** Indicates if node is enabled or disabled. */
  enabled: boolean;
  /** Readonly revision metadata of the node object. */
  metadata:
    | Metadata
    | undefined;
  /** Serial number of the node. Serial number cannot be nullified. */
  serialNumber: string;
  /** Hardware model name of the node. Model name cannot be nullified. */
  modelName: string;
  /** Operating system type of the node (E.g. SONiC, NEXUS etc.). OsType cannot be nullified. */
  osType: OsType;
  /** Node type (E.g. BLUEPRINT, SWITCH etc.). Node type is readonly. */
  nodeType: NodeType;
  /** Position of Node in the fabric's node list. Position is readonly. */
  position: number;
  /** The identifier of Fabric to which the node belongs. Fabric identifier is readonly. */
  fabricId: string;
  /** The identifier of bound (attached) physical device. Device identifier is readonly. */
  deviceId: string;
  /** A user-defined location string (E.g. SJC20). */
  location: string;
  /**
   * A set of roles of the Node. Node roles are mandatory. A Node can
   * have either LEAF or SPINE role, but not both.
   */
  roles: NodeRole[];
  /** NetworkPort objects of the node. Ports are optional for node updates. */
  ports: NetworkPort[];
  /**
   * Fabric connection objects of the node. Note that connection list do not have
   * host (endpoint) connections.
   */
  connections: PortConnection[];
  /** Management ports for the node. */
  managementPorts: ManagementPort[];
  /**
   * Port breakout configs of the node. Breakouts are set only when entire Fabric
   * config is queried.
   */
  breakouts: PortBreakout[];
  /** Airflows and corresponding psu models of the node. */
  psuAirflows: PsuAirflow[];
  /**
   * HwSetId defines the hardware set that this node belongs to. For child nodes this
   * represents the hw_set_id of the parent.
   */
  hwSetId: string;
  /**
   * Group_id defines the server or switch group that this node belongs to. For child nodes
   * this represents the group_id of the parent
   */
  groupId: string;
  /** Position of Node in the hw set it belongs to in the design. Hw set position is readonly. */
  hwSetNodePosition: number;
  /** BMC & LOM ports for the node. */
  serverMgmtPorts: ServerMgmtPort[];
  /** The identifier of parent node. */
  parentId: string;
  /** The tray or slot identifier of the node within the parent node. */
  trayId: number;
  /** A permanent MAC address identifying this tray's slot position in the rack. */
  trayDeviceId: string;
  /** Desired configuration for BMC endpoints owned by this node. */
  bmcConfigs: BmcConfig[];
}

/**
 * A Fabric is a collection of nodes, connections that represents the interconnections
 * between the nodes, the configuration of the ports of the nodes and the logical constructs
 * deployed across the fabric such as VRFs, logical networks named VNIs and other services.
 */
export interface Fabric {
  /**
   * The unique identifier of the fabric.
   *
   * INTERNAL
   *
   * Identifier is required to update an existing Fabric.
   * If identifier is missing, then set operation defaults to CREATE mode.
   */
  id: string;
  /**
   * The user-defined name of the fabric.
   *
   * INTERNAL
   *
   * Fabric name is unique, and is case-insensitive.
   */
  name: string;
  /** The description is a user-defined field to store notes about the fabric. */
  description: string;
  /** A list of user-defined labels that can be used for grouping and filtering fabrics. */
  labels: string[];
  /**
   * A list of name-value annotations to store user-defined data including complex data such as
   * JSON associated with the fabric.
   */
  annotations: Annotation[];
  /** The enabled state of the fabric which indicates if the fabric is enabled or disabled. */
  enabled: boolean;
  /** A map of attributes related to the lifecycle of the fabric. */
  metadata:
    | Metadata
    | undefined;
  /** The revision identifier of committed config. This field is readonly. */
  candidateId: string;
  /** The type of topology of the fabric. */
  topology: FabricTopology;
  /** Entitlement level of the fabric.. */
  level: EntitlementLevel;
  /** The type of fabric (BLUEPRINT or INVENTORY). */
  fabricType: FabricType;
  /**
   * The location is a user-defined field to store information about the location of the
   * fabric (E.g. SJC01).
   */
  location: string;
  /** The physical street address where the fabric is located (E.g. 320 My Street). */
  address: string;
  /** The city in which the fabric is located (E.g. San Jose). */
  city: string;
  /** The country code in which the fabric is located (E.g. US). */
  country: string;
  /**
   * A list of nodes that are part of the fabric.
   *
   * INTERNAL
   *
   * Nodes are optional during fabric modification. If provided, Nodes set must be a full set.
   */
  nodes: Node[];
  /**
   * A list of fabric connections that represents the interconnections between nodes in a fabric.
   *
   * INTERNAL
   *
   * Connections are optional during Fabric modification. If provided, Connections set must
   * be a full set.
   */
  connections: PortConnection[];
  /** The Static Anycast Gateway's MAC address for the fabric. */
  sagMac: string;
  /**
   * The number of active candidate configurations of the fabric.
   *
   * INTERNAL
   *
   * NumCandidates is readonly.
   */
  numCandidates: number;
  /**
   * A list of nodes that are discovered but not recognized by the Hyperfabric service.
   *
   * INTERNAL
   *
   * GetFabrics API does not return unrecognized nodes.
   * However, GetFabricInventories API sets Unrecognized nodes when it finds non-service switches.
   */
  unrecognized: Node[];
  /** The design associated with the fabric for v2 fabrics */
  design:
    | FabricDesign
    | undefined;
  /** A list of internal labels used for resource reservations and other internal purposes. */
  internalLabels: string[];
}

/**
 * The Static Routes object is a child object of a VRF that encapsulates a set of IP static
 * routes pointing to a next-hop. The next-hop must be accessible through one of the routed
 * interfaces associated with the parent VRF.
 */
export interface StaticRoutes {
  /**
   * The unique identifier of the static routes object.
   *
   * INTERNAL
   *
   * Identifier is required to update an existing StaticRoutes.
   * If identifier is missing, then set operation defaults to CREATE mode.
   */
  id: string;
  /**
   * The user-defined name of the static routes. The static routes name has to be unique, and
   * is case-insensitive.
   */
  name: string;
  /** The description is a user-defined field to store notes about the static routes. */
  description: string;
  /** A list of user-defined labels that can be used for grouping and filtering static routes. */
  labels: string[];
  /**
   * A list of name-value annotations to store user-defined data including complex data such as JSON
   * associated with the static routes.
   */
  annotations: Annotation[];
  /**
   * The enabled state of the static routes which indicates if the static routes is enabled or
   * disabled.
   */
  enabled: boolean;
  /** A map of attributes related to the lifecycle of the static routes. */
  metadata:
    | Metadata
    | undefined;
  /**
   * The unique identifier of the fabric to which this static routes belong.
   *
   * INTERNAL
   *
   * Fabric identifier is mandatory.
   */
  fabricId: string;
  /** A list of IP static route definitions. */
  routes: RouteInfo[];
  /**
   * The unique identifier of the VRF to which this static routes belong to.
   * The VRF identifier is immutable once set.
   */
  vrfId: string;
}

/**
 * A VRF is a virtual-routing-and-forwarding instance that represents a routing table
 * deployed across nodes in the fabric to implement VRF-lite and the ability
 * to have multiple routing tables on a single device.
 * A VRF can be associated to multiple VNIs configured with an Anycast Gateway SVI.
 *
 * INTERNAL
 *
 * Vrf encapsulates properties of a virtual-routing-and-forwarding object.
 * Vrf allows having more than one routing tables on a single switch. Vrf
 * implements VRF-lite (IP VRF), or VRF without MPLS.
 *
 *  1) A Vrf is a tenant object, and is inactive until it is attached to a Vni.
 *  2) There is a one-to-one relationship between Vrf and a L3VNI.
 *  3) A Vrf maybe attached to several L2VNI objects.
 */
export interface Vrf {
  /**
   * The unique identifier of the VRF.
   *
   * INTERNAL
   *
   * Identifier is required to update an existing Vrf.
   * If identifier is missing, then set operation defaults to CREATE mode.
   */
  id: string;
  /**
   * The user-defined name of the VRF. The VRF name has to be unique, and is case-insensitive.
   * The name should start with `Vrf`, `VRF`, `VRf` or `VrF`, followed by an optional `-` separator
   * and end with an alpha-numeric string of 1 to 16 character.
   */
  name: string;
  /** The description is a user-defined field to store notes about the VRF. */
  description: string;
  /** A list of user-defined labels that can be used for grouping and filtering VRFs. */
  labels: string[];
  /**
   * A list of name-value annotations to store user-defined data including complex data such as JSON
   * associated with the VRF.
   */
  annotations: Annotation[];
  /** The enabled state of the VRF which indicates if the VRF is enabled or disabled. */
  enabled: boolean;
  /** A map of attributes related to the lifecycle of the VRF. */
  metadata:
    | Metadata
    | undefined;
  /**
   * The unique identifier of the fabric to which this VRF belongs to.
   *
   * INTERNAL
   *
   * Fabric identifier is mandatory.
   */
  fabricId: string;
  /** A list of interfaces that are associated with the VRF. */
  interfaces: NetworkInterface[];
  /** The flag that indicates if the VRF is the default (auto-created) VRF or not. */
  isDefault: boolean;
  /**
   * The VXLAN Network Identifier (VNI) used for the VRF.
   *
   * INTERNAL
   *
   * VNI of the parent L3VNI.
   */
  vni: number;
  /** The Autonomous System Number (ASN) used for the VRF external BGP peering. */
  asn: number;
  /**
   * An IPv4 address range of Loopbacks in CIDR format or as a comma-separated list of IPv4
   * addresses to be configured on all switches as source addresses of the VRF for various
   * functions such as DHCP relay and IP SLA probes. The number of IP addresses provided
   * should be large enough to create Loopbacks on all switches in the fabric.
   *
   * INTERNAL
   *
   * IPv4 address range of DHCP relay Loopbacks. Loopbacks are created when DHCP relays
   * are attached to a VRF. Loopbacks may also be created for other purposes. Caller
   * must provide a network IP in CIDR format (E.g. 10.10.2.0/24) or a distinct set of
   * IP addresses (E.g. 10.10.1.1, 10.10.1.5. 10.10.2.3 etc.). IP range should be large
   * enough to create Loopbacks on all switches in the fabric.
   * E.g. 10.10.10.0/24
   */
  ipv4Loopbacks: string[];
  /**
   * An IPv6 address range of Loopbacks in CIDR format addresses to be configured on all
   * switches as source addresses of the VRF for various functions such as DHCP relay
   * and IP SLA probes. The number of IP addresses provided should be large enough
   * to create Loopbacks on all switches in the fabric.
   *
   * INTERNAL
   *
   * IPv6 address range of DHCP relay Loopbacks. Caller must provide a network IP in CIDR
   * format. IP range should be large enough to create Loopbacks on all switches in the fabric.
   * E.g. 3000::0/112
   */
  ipv6Loopbacks: string[];
  /**
   * The fabric unique component of VRF route-target. Do not use; internal use only.
   *
   * INTERNAL
   */
  routeTarget: string;
  /**
   * The name of the Auto-generated Loopback. This field is read-only, and is set
   * only when either IPv4 or IPv6 loopback addresses are provided.
   */
  loopback: string;
}

/**
 * A VLAN is a Layer 2 logical network that allows a group of devices on one or more Local
 * Area Networks (LANs) to communicate as if they were attached to the same wire.
 * Each VLAN creates a separate broadcast domain which is the set of all devices that will
 * receive broadcast frames originating from any device within the set.
 *
 * INTERNAL
 *
 * Vlan represents a Vlan in a tenancy.
 * A VLAN encapsulates a VLAN identifier, and
 * a set of network ports from leaf node. Vlan is locally significant, meaning
 * a Vlan is meaningful only within the switch. The service allows creating "global"
 * Vlan, however it is meaningful only in the context of a switch.
 *
 *          VLAN-ID      Ports
 *         ---------    -------
 * Leaf0:
 *           10         [Ethernet1_1, Ethernet1_8]
 *           20         [Ethernet1_4, Ethernet1_12]
 * Leaf1:
 *           10         [Ethernet1_16, Ethernet1_32]
 *           20         [Ethernet1_1, Ethernet1_12]
 *
 * NOTES: Vlan always belong to a Vni.
 */
export interface Vlan {
  /**
   * The unique identifier of the VLAN.
   *
   * INTERNAL
   *
   * Identifier is required to update an existing
   * Vlan. If identifier is missing, then set operation defaults to CREATE mode.
   */
  id: string;
  /** The user-defined name of the VLAN. The VLAN name has to be unique, and is case-insensitive. */
  name: string;
  /** The description is a user-defined field to store notes about the VLAN. */
  description: string;
  /** A list of user-defined labels that can be used for grouping and filtering VLANs. */
  labels: string[];
  /**
   * A list of name-value annotations to store user-defined data including complex data such as JSON
   * associated with the VLAN.
   */
  annotations: Annotation[];
  /** The enabled state of the VLAN which indicates if the VLAN is enabled or disabled. */
  enabled: boolean;
  /** A map of attributes related to the lifecycle of the VLAN. */
  metadata:
    | Metadata
    | undefined;
  /** The identifier of the fabric to which this VLAN belongs to. */
  fabricId: string;
  /**
   * The VLAN ID used as dot1q encapsulation for the VLAN. The VLAN ID must be between 2 and 3600.
   *
   * INTERNAL
   *
   * The service reserves Vlan identifier between 3601 and 4096.
   */
  vlanId: number;
  /**
   * A list of Switch Virtual Interfaces (SVIs) for the VLAN.
   *
   * INTERNAL
   *
   * SVI objects are optional for Vlan updates.
   * However, if SVI objects are supplied, then it must be a full set.
   */
  svis: Svi[];
  /** A list of member ports or port channels of the VLAN. */
  members: VlanMember[];
  /**
   * The VXLAN Network Identifier (VNI) to which this VLAN is attached to.
   *
   * INTERNAL
   *
   * Vni is readonly.
   */
  vni: number;
  /**
   * The unique identifier of the VRF to which this VLAN is attached to.
   *
   * INTERNAL
   *
   * Vrf identifier is readonly.
   */
  vrfId: string;
}

/**
 * A VNI represents a Layer 2 or Layer 3 logical network that can be extended across the fabric
 * and mapped to a VLAN ID on specific ports and port channels.
 * A VNI can be mapped to a VRF and configured with an SVI to serve as an Anycast Gateway.
 *
 * INTERNAL
 *
 * Vni encapsulates properties of a L2/L3 logical network (VNI). Vni has two distinct
 * modes - L2VNI and L3VNI. In L3VNI mode, Vni allows bidirectional flow of traffic
 * between a Layer-2 bridged network and a Layer-3 routed network. Whereas, in L2VNI
 * mode, Vni allows traffic between all participating ports through a subnet.
 *
 * Vni spans two or more ports from multiple nodes. In L3VNI mode, Vni also has IP
 * interfaces on all nodes. Each Node may have separate IP interface or a single
 * anycast gateway IP address that spans all nodes. L3VNI also has a default VRF that
 * gets added automatically when Vni is created. User may not change default VRF.
 *
 *   Leaf0::Ethernet1_1 ---->
 *                          | ---> Vlan --> Vni (VRF in L3VNI mode)
 *   Leaf1::Ethernet1_8 ---->
 *
 * The service automatically allocates a VNI for Vni object. User may set a VNI during
 * Vni creation. However, user may not change an existing VNI.
 *
 * Tabular representation of VNIs on a fabric.
 * +--------+--------+---------+---------------+-----------------------------------------------+
 * |  VNI   |  VLAN  | Switch  |     Port      | Comments                                      |
 * +--------+--------+---------+---------------+-----------------------------------------------+
 * |  5000  |   0    |    *    |       *       | Host ports from all switches are assigned to  |
 * |        |        |         |               | VNI 5000 as untagged members. VNI 5000 gets   |
 * |        |        |         |               | an internal VLAN tag.                         |
 * +--------+--------+---------+---------------+-----------------------------------------------+
 * |  6000  |   60   |    *    |       *       | Host ports from all switches are assigned to  |
 * |        |        |         |               | VNI 6000. VNI 6000 has a VLAN tag of 60 on    |
 * |        |        |         |               | all switches.                                 |
 * +--------+--------+---------+---------------+-----------------------------------------------+
 * |  6000  |   60   |    *    |  Ethernet1_3  | Ethernet1_3 from all switches are assigned to |
 * |        |        |         |               | VNI 6000 with a VLAN tag of 60.               |
 * +--------+--------+---------+---------------+-----------------------------------------------+
 * |  6000  |   61   |    2    |  Ethernet1_4  | Ethernet1_4 from switch-2 is assigned to VNI  |
 * |        |        |         |               | 6000 with a VLAN tag of 61. VNI 6000 on       |
 * |        |        |         |               | switch-2 will have just one port in it.       |
 * +--------+--------+---------+---------------+-----------------------------------------------+
 * |  6000  |   61   |    2    |  Ethernet1_5  | Ethernet1_5 from switch-2 is assigned to VNI  |
 * |        |        |         |               | 6000 with a VLAN tag of 61. On switch-2, VNI  |
 * |        |        |         |               | 6000 will have Ethernet1_4 and Ethernet1_5 as |
 * |        |        |         |               | member ports with a VLAN tag of 61.           |
 * +--------+--------+---------+---------------+-----------------------------------------------+
 * |  7000  |   70   |    *    |  Ethernet1_5  | Ethernet1_5 from all switches are assigned to |
 * |        |        |         |               | VNI 7000 with a VLAN tag of 70.               |
 * +--------+--------+---------+---------------+-----------------------------------------------+
 * |  8000  |   0    |    *    |  Ethernet1_6  | Ethernet1_6 from all switches are assigned to |
 * |        |        |         |               | VNI 8000 as untagged member. VNI 8000 gets an |
 * |        |        |         |               | internal VLAN tag. Ethernet1_6 is removed     |
 * |        |        |         |               | from VNI 5000 on all switches. .              |
 * +--------+--------+---------+---------------+-----------------------------------------------+
 */
export interface Vni {
  /**
   * The unique identifier of the VNI.
   *
   * INTERNAL
   *
   * Identifier is required to update an existing
   * Vni. If identifier is missing, then set operation defaults to CREATE mode.
   */
  id: string;
  /** The user-defined name of the VNI. The VNI name has to be unique, and is case-insensitive. */
  name: string;
  /** The description is a user-defined field to store notes about the VNI. */
  description: string;
  /** A list of user-defined labels that can be used for grouping and filtering VNIs. */
  labels: string[];
  /**
   * A list of name-value annotations to store user-defined data including complex data such as JSON
   * associated with the VNI.
   */
  annotations: Annotation[];
  /** The enabled state of the VNI which indicates if the VNI is enabled or disabled. */
  enabled: boolean;
  /** A map of attributes related to the lifecycle of the VNI. */
  metadata:
    | Metadata
    | undefined;
  /**
   * The unique identifier of the fabric to which this VNI belongs to.
   *
   * INTERNAL
   *
   * Fabric identifier or fabric name must be provided.
   */
  fabricId: string;
  /**
   * The VLAN ID of the L2VNI.
   *
   * INTERNAL
   */
  vlanId: number;
  /**
   * The VXLAN Network Identifier (VNI) used for the VNI.
   * The value must be between 2 and 6000000.
   *
   * INTERNAL
   *
   * The service allocates a VNI if not provided.
   * The service reserves VNI values above 6000000 (6M).
   */
  vni: number;
  /** The flag that indicates if the VNI is the default (auto-created) VNI or not. */
  isDefault: boolean;
  /**
   * The Maximum Transfer Unit (MTU) of the SVI of the VNI.
   * The value must be between 1500 and 9100.
   *
   * INTERNAL
   *
   * MTU of all member network ports will inherit this MTU.
   */
  mtu: number;
  /**
   * A list of member ports or port channels of the VNI.
   *
   * INTERNAL
   *
   * Must provide member ports during VNI creation.
   */
  members: VlanMember[];
  /**
   * The flag that indicates if the VNI is in L3VNI mode or not.
   *
   * INTERNAL
   *
   * The service will create A VRF in L3VNI mode.
   * Once set, user may not change mode from L3VNI to L2VNI or vice versa.
   */
  isL3: boolean;
  /**
   * A list of Switch Virtual Interfaces (SVIs) for the VNI.
   *
   * INTERNAL
   *
   * SVIs can be configured on VNIs in L3VNI or L2VNI mode.
   * L2VNI rules:
   *   1) There must be exactly one static-anycast-gateway (SAG) enabled SVI entry.
   *   2) NodeId attribute of SVI must be empty.
   * L3VNI rules:
   *   1) There must be one SVI per node per Vlan.
   *   2) NodeId attribute of SVI must be set to the node where SVI should be active.
   */
  svis: Svi[];
  /**
   * The unique identifier of the VRF associated with the VNI.
   *
   * INTERNAL
   *
   * L2VNI:
   *   1) VNI must have an SVI.
   *   2) VRF belongs to a separate L3VNI object.
   *   3) If vrf_id is empty, then SVI is added to the default VRF.
   * L3VNI:
   *   1) VRF belongs to the L3VNI itself.
   *   2) Vni automatically creates a VRF.
   *   3) SVIs of L3VNI are automatically added to the VRF.
   */
  vrfId: string;
  /**
   * The tag to be used for IP addresses in the same subnet as SVIs of VNI.
   * RouteTag is meaningful only when there are SVIs attached to the VNI.
   */
  tag: RouteTag;
}

/**
 * A Loopback is a logical network interface of a Node used as source interface to peer at Layer 3 with external devices.
 *
 * INTERNAL
 *
 * Loopback represents a loopback device in a switch. Loopback encapsulates
 * an IPv4 address, and an optional IPv6 address.
 */
export interface Loopback {
  /**
   * The unique identifier of the loopback.
   *
   * INTERNAL
   *
   * The unique identifier of Loopback. Identifier is required to update an existing
   * Loopback. If identifier is missing, then set operation defaults to CREATE mode.
   */
  id: string;
  /**
   * The name of the loopback. Must be in the format Loopback\<Integer\>.
   *
   * INTERNAL
   *
   * The user-defined name of the Loopback. Loopback name is unique within a node.
   * Loopback name has a fixed prefix of Loopback and an integer suffix (Eg. Loopback10).
   */
  name: string;
  /** The description is a user-defined field to store notes about the loopback. */
  description: string;
  /** A list of user-defined labels that can be used for grouping and filtering loopbacks. */
  labels: string[];
  /**
   * A list of name-value annotations to store user-defined data including complex data such as JSON
   * associated with the loopback.
   */
  annotations: Annotation[];
  /** The enabled state of the loopback which indicates if the loopback is enabled or disabled. */
  enabled: boolean;
  /** A map of attributes related to the lifecycle of the loopback. */
  metadata:
    | Metadata
    | undefined;
  /**
   * The unique identifier of the fabric to which this loopback belongs to.
   *
   * INTERNAL
   *
   * The fabric identifier to which this Loopback belongs to.
   */
  fabricId: string;
  /**
   * The unique identifier of the node to which this loopback belongs to.
   *
   * INTERNAL
   *
   * The node identifier to which this Loopback belongs to.
   */
  nodeId: string;
  /** The IPv4 host address with subnet mask to be configured on the loopback. */
  ipv4Address: string;
  /** The IPv6 host address with subnet mask to be configured on the loopback. */
  ipv6Address: string;
  /**
   * The tag to be used for the Loopback IP addresses. Tag is used when a BGP
   * policy has route filter (rule) using the tag.
   */
  tag: RouteTag;
  /**
   * The unique identifier of the VRF to which this loopback is attached to.
   *
   * INTERNAL
   *
   * Vrf object attached to this Loopback. Vrf identifier is readonly.
   */
  vrfId: string;
  /** A flag that indicates if the loopback was automatically created by the system. */
  autoCreated: boolean;
}

/**
 * A DHCP Relay is a network function attached to one or more VNIs in a VRF to relay DHCP
 * requests to a DHCP server located in another VNI.
 *
 * INTERNAL
 *
 * DhcpRelay encapsulates properties of a DHCP relay object. A DhcpRelay is
 * a child of Vrf, and all VNI/VLANs attached to the DhcpRelay must be in the
 * Vrf. A DhcpRelay must have host IP addresses of the DHCP server, and a set
 * of VNI objects that need DHCP relay feature.
 */
export interface DhcpRelay {
  /**
   * The unique identifier of the DHCP relay.
   *
   * INTERNAL
   *
   * The unique identifier of DhcpRelay. Identifier is required to update an existing
   * DhcpRelay. If identifier is missing, then set operation defaults to CREATE mode.
   */
  id: string;
  /**
   * The name of the DHCP relay.
   *
   * INTERNAL
   *
   * The user-defined name of the DhcpRelay. DhcpRelay name is unique, and is case-insensitive.
   */
  name: string;
  /** The description is a user-defined field to store notes about the DHCP relay. */
  description: string;
  /** A list of user-defined labels that can be used for grouping and filtering DHCP relays. */
  labels: string[];
  /**
   * A list of name-value annotations to store user-defined data including complex data such as JSON
   * associated with the DHCP relay.
   */
  annotations: Annotation[];
  /** The enabled state of the DHCP relay which indicates if the DHCP relay is enabled or disabled. */
  enabled: boolean;
  /** A map of attributes related to the lifecycle of the DHCP relay. */
  metadata:
    | Metadata
    | undefined;
  /**
   * The unique identifier of the fabric to which this DHCP relay belongs to.
   *
   * INTERNAL
   *
   * The identifier of Fabric to which this DhcpRelay belong. Fabric identifier is mandatory,
   * and immutable once set.
   */
  fabricId: string;
  /**
   * The unique identifier of the VRF associated with the DHCP relay.
   *
   * INTERNAL
   *
   * The identifier of Vrf to which this DhcpRelay belong. Vrf identifier is mandatory, and
   * immutable once set.
   */
  vrfId: string;
  /**
   * A list of up to two IPv4 host addresses of the DHCP servers to relay DHCP requests to.
   *
   * INTERNAL
   *
   * IPv4 addresses of DHCP server. May provided a maximum of 2 IPv4 addresses.
   */
  ipv4Addresses: string[];
  /**
   * A list of up to two IPv6 host addresses of the DHCP servers to relay DHCP requests to.
   *
   * INTERNAL
   *
   * IPv6 addresses of DHCP server. May provided a maximum of 2 IPv6 addresses.
   */
  ipv6Addresses: string[];
  /**
   * A list of up to 30 DHCP relay VNI specifications to attach the DHCP relay to.
   *
   * INTERNAL
   *
   * DHCP relay specification on a per VNI basis. User may specify a maximum of 30 VNIs.
   */
  vnis: VniDhcp[];
}

/**
 * A Breakout defines the mode in which high-speed, channelized Node Ports are each broken down into
 * multiple low-speed Breakout Ports, each connecting to separate network elements.
 * For example, a switch with 400G ports can be connected to four 100G ports.
 *
 * INTERNAL
 *
 * PortBreakout encapsulates a network port breakout policy. PortBreakout does not
 * represent a configurable object. It is a policy that gets applied to a switch.
 */
export interface PortBreakout {
  /**
   * The unique identifier of the breakout.
   *
   * INTERNAL
   *
   * The unique identifier of PortBreakout. Identifier is required to update an existing
   * PortBreakout. If identifier is missing, then set operation defaults to CREATE mode.
   */
  id: string;
  /** The user-defined name of the breakout. */
  name: string;
  /** The description is a user-defined field to store notes about the breakout. */
  description: string;
  /** A list of user-defined labels that can be used for grouping and filtering breakouts. */
  labels: string[];
  /**
   * A list of name-value annotations to store user-defined data including complex data such as JSON
   * associated with the Port Breakout.
   */
  annotations: Annotation[];
  /** The enabled state of the breakout which indicates if the breakout is enabled or disabled. */
  enabled: boolean;
  /** A map of attributes related to the lifecycle of the breakout. */
  metadata:
    | Metadata
    | undefined;
  /**
   * The unique identifier of the fabric to which this breakout belongs to.
   *
   * INTERNAL
   *
   * The identifier of Fabric to which this PortBreakout belongs to. FabricId is mandatory.
   */
  fabricId: string;
  /**
   * The unique identifier of the node to which this breakout belongs to.
   *
   * INTERNAL
   *
   * The identifier of the node for which the PortBreakout is for. NodeId is mandatory.
   */
  nodeId: string;
  /**
   * The type or name of the model (PID) of the pluggable cable or optic expected to be used
   * for the breakout.
   */
  pluggable: string;
  /** The mode used to breakout the ports. E.g. 2x200G(2) */
  mode: string;
  /** A list of node port names to be broken down into breakout ports based on the breakout `mode`. */
  ports: string[];
  /**
   * A list of breakout port names which are the result of the `ports` being broken down based
   * on the breakout `mode`.
   */
  breakouts: string[];
}

/** Mapping of GPU numbers to slots and NIC slots */
export interface SlotMapConfiguration {
  /** Slot number corresponding to the gpu. */
  gpuSlot: number;
  /** NicSlots is the associated Nic slot mapping. */
  nicSlots: number[];
}

export interface GpuMode {
  /** Number of GPUs in this mode/configuration (2,4,6,8). */
  numGpus: number;
  /** Enabled represents whether or not the configuration is permitted. */
  enabled: boolean;
  /** RecommendedSlots represents the recommended slot placement for a specific number of gpus. */
  recommendedSlots: string[];
}

/** Port summary for each device based on speed and pluggable. */
export interface PortSummaryInfo {
  /** A list of speeds corresponding to a set of ports. */
  portSpeed: string;
  /** The form factor pluggable for the given port speed. */
  pluggable: string;
  /** The number of ports with the given speed on the device. */
  numPorts: number;
}

function createBaseNetworkPort(): NetworkPort {
  return {
    id: "",
    name: "",
    nodeId: "",
    description: "",
    labels: [],
    annotations: [],
    enabled: false,
    metadata: undefined,
    index: 0,
    breakout: false,
    breakoutIndex: 0,
    linecard: 0,
    vrfId: "",
    vlanIds: [],
    vnis: [],
    fec: "",
    roles: [],
    linkDown: false,
    ipv4Addresses: [],
    ipv6Addresses: [],
    subInfCount: 0,
    stp: undefined,
    tag: 0,
    pluggable: "",
    mtu: 0,
    maxSpeed: "",
    speed: "",
    forceCounter: 0,
    portAlias: "",
  };
}

export const NetworkPort: MessageFns<NetworkPort> = {
  encode(message: NetworkPort, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.name !== "") {
      writer.uint32(18).string(message.name);
    }
    if (message.nodeId !== "") {
      writer.uint32(26).string(message.nodeId);
    }
    if (message.description !== "") {
      writer.uint32(34).string(message.description);
    }
    for (const v of message.labels) {
      writer.uint32(42).string(v!);
    }
    for (const v of message.annotations) {
      Annotation.encode(v!, writer.uint32(50).fork()).join();
    }
    if (message.enabled !== false) {
      writer.uint32(56).bool(message.enabled);
    }
    if (message.metadata !== undefined) {
      Metadata.encode(message.metadata, writer.uint32(66).fork()).join();
    }
    if (message.index !== 0) {
      writer.uint32(80).uint32(message.index);
    }
    if (message.breakout !== false) {
      writer.uint32(88).bool(message.breakout);
    }
    if (message.breakoutIndex !== 0) {
      writer.uint32(96).uint32(message.breakoutIndex);
    }
    if (message.linecard !== 0) {
      writer.uint32(104).uint32(message.linecard);
    }
    if (message.vrfId !== "") {
      writer.uint32(114).string(message.vrfId);
    }
    writer.uint32(122).fork();
    for (const v of message.vlanIds) {
      writer.uint32(v);
    }
    writer.join();
    writer.uint32(130).fork();
    for (const v of message.vnis) {
      writer.uint32(v);
    }
    writer.join();
    if (message.fec !== "") {
      writer.uint32(138).string(message.fec);
    }
    writer.uint32(162).fork();
    for (const v of message.roles) {
      writer.int32(v);
    }
    writer.join();
    if (message.linkDown !== false) {
      writer.uint32(168).bool(message.linkDown);
    }
    for (const v of message.ipv4Addresses) {
      writer.uint32(178).string(v!);
    }
    for (const v of message.ipv6Addresses) {
      writer.uint32(186).string(v!);
    }
    if (message.subInfCount !== 0) {
      writer.uint32(192).uint32(message.subInfCount);
    }
    if (message.stp !== undefined) {
      InterfaceStp.encode(message.stp, writer.uint32(202).fork()).join();
    }
    if (message.tag !== 0) {
      writer.uint32(208).int32(message.tag);
    }
    if (message.pluggable !== "") {
      writer.uint32(234).string(message.pluggable);
    }
    if (message.mtu !== 0) {
      writer.uint32(240).uint32(message.mtu);
    }
    if (message.maxSpeed !== "") {
      writer.uint32(250).string(message.maxSpeed);
    }
    if (message.speed !== "") {
      writer.uint32(258).string(message.speed);
    }
    if (message.forceCounter !== 0) {
      writer.uint32(264).uint32(message.forceCounter);
    }
    if (message.portAlias !== "") {
      writer.uint32(274).string(message.portAlias);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): NetworkPort {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseNetworkPort();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.nodeId = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.description = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.labels.push(reader.string());
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.annotations.push(Annotation.decode(reader, reader.uint32()));
          continue;
        }
        case 7: {
          if (tag !== 56) {
            break;
          }

          message.enabled = reader.bool();
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.metadata = Metadata.decode(reader, reader.uint32());
          continue;
        }
        case 10: {
          if (tag !== 80) {
            break;
          }

          message.index = reader.uint32();
          continue;
        }
        case 11: {
          if (tag !== 88) {
            break;
          }

          message.breakout = reader.bool();
          continue;
        }
        case 12: {
          if (tag !== 96) {
            break;
          }

          message.breakoutIndex = reader.uint32();
          continue;
        }
        case 13: {
          if (tag !== 104) {
            break;
          }

          message.linecard = reader.uint32();
          continue;
        }
        case 14: {
          if (tag !== 114) {
            break;
          }

          message.vrfId = reader.string();
          continue;
        }
        case 15: {
          if (tag === 120) {
            message.vlanIds.push(reader.uint32());

            continue;
          }

          if (tag === 122) {
            const end2 = reader.uint32() + reader.pos;
            while (reader.pos < end2) {
              message.vlanIds.push(reader.uint32());
            }

            continue;
          }

          break;
        }
        case 16: {
          if (tag === 128) {
            message.vnis.push(reader.uint32());

            continue;
          }

          if (tag === 130) {
            const end2 = reader.uint32() + reader.pos;
            while (reader.pos < end2) {
              message.vnis.push(reader.uint32());
            }

            continue;
          }

          break;
        }
        case 17: {
          if (tag !== 138) {
            break;
          }

          message.fec = reader.string();
          continue;
        }
        case 20: {
          if (tag === 160) {
            message.roles.push(reader.int32() as any);

            continue;
          }

          if (tag === 162) {
            const end2 = reader.uint32() + reader.pos;
            while (reader.pos < end2) {
              message.roles.push(reader.int32() as any);
            }

            continue;
          }

          break;
        }
        case 21: {
          if (tag !== 168) {
            break;
          }

          message.linkDown = reader.bool();
          continue;
        }
        case 22: {
          if (tag !== 178) {
            break;
          }

          message.ipv4Addresses.push(reader.string());
          continue;
        }
        case 23: {
          if (tag !== 186) {
            break;
          }

          message.ipv6Addresses.push(reader.string());
          continue;
        }
        case 24: {
          if (tag !== 192) {
            break;
          }

          message.subInfCount = reader.uint32();
          continue;
        }
        case 25: {
          if (tag !== 202) {
            break;
          }

          message.stp = InterfaceStp.decode(reader, reader.uint32());
          continue;
        }
        case 26: {
          if (tag !== 208) {
            break;
          }

          message.tag = reader.int32() as any;
          continue;
        }
        case 29: {
          if (tag !== 234) {
            break;
          }

          message.pluggable = reader.string();
          continue;
        }
        case 30: {
          if (tag !== 240) {
            break;
          }

          message.mtu = reader.uint32();
          continue;
        }
        case 31: {
          if (tag !== 250) {
            break;
          }

          message.maxSpeed = reader.string();
          continue;
        }
        case 32: {
          if (tag !== 258) {
            break;
          }

          message.speed = reader.string();
          continue;
        }
        case 33: {
          if (tag !== 264) {
            break;
          }

          message.forceCounter = reader.uint32();
          continue;
        }
        case 34: {
          if (tag !== 274) {
            break;
          }

          message.portAlias = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): NetworkPort {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      name: isSet(object.name) ? globalThis.String(object.name) : "",
      nodeId: isSet(object.nodeId) ? globalThis.String(object.nodeId) : "",
      description: isSet(object.description) ? globalThis.String(object.description) : "",
      labels: globalThis.Array.isArray(object?.labels) ? object.labels.map((e: any) => globalThis.String(e)) : [],
      annotations: globalThis.Array.isArray(object?.annotations)
        ? object.annotations.map((e: any) => Annotation.fromJSON(e))
        : [],
      enabled: isSet(object.enabled) ? globalThis.Boolean(object.enabled) : false,
      metadata: isSet(object.metadata) ? Metadata.fromJSON(object.metadata) : undefined,
      index: isSet(object.index) ? globalThis.Number(object.index) : 0,
      breakout: isSet(object.breakout) ? globalThis.Boolean(object.breakout) : false,
      breakoutIndex: isSet(object.breakoutIndex) ? globalThis.Number(object.breakoutIndex) : 0,
      linecard: isSet(object.linecard) ? globalThis.Number(object.linecard) : 0,
      vrfId: isSet(object.vrfId) ? globalThis.String(object.vrfId) : "",
      vlanIds: globalThis.Array.isArray(object?.vlanIds) ? object.vlanIds.map((e: any) => globalThis.Number(e)) : [],
      vnis: globalThis.Array.isArray(object?.vnis) ? object.vnis.map((e: any) => globalThis.Number(e)) : [],
      fec: isSet(object.fec) ? globalThis.String(object.fec) : "",
      roles: globalThis.Array.isArray(object?.roles) ? object.roles.map((e: any) => portRoleFromJSON(e)) : [],
      linkDown: isSet(object.linkDown) ? globalThis.Boolean(object.linkDown) : false,
      ipv4Addresses: globalThis.Array.isArray(object?.ipv4Addresses)
        ? object.ipv4Addresses.map((e: any) => globalThis.String(e))
        : [],
      ipv6Addresses: globalThis.Array.isArray(object?.ipv6Addresses)
        ? object.ipv6Addresses.map((e: any) => globalThis.String(e))
        : [],
      subInfCount: isSet(object.subInfCount) ? globalThis.Number(object.subInfCount) : 0,
      stp: isSet(object.stp) ? InterfaceStp.fromJSON(object.stp) : undefined,
      tag: isSet(object.tag) ? routeTagFromJSON(object.tag) : 0,
      pluggable: isSet(object.pluggable) ? globalThis.String(object.pluggable) : "",
      mtu: isSet(object.mtu) ? globalThis.Number(object.mtu) : 0,
      maxSpeed: isSet(object.maxSpeed) ? globalThis.String(object.maxSpeed) : "",
      speed: isSet(object.speed) ? globalThis.String(object.speed) : "",
      forceCounter: isSet(object.forceCounter) ? globalThis.Number(object.forceCounter) : 0,
      portAlias: isSet(object.portAlias) ? globalThis.String(object.portAlias) : "",
    };
  },

  toJSON(message: NetworkPort): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.name !== "") {
      obj.name = message.name;
    }
    if (message.nodeId !== "") {
      obj.nodeId = message.nodeId;
    }
    if (message.description !== "") {
      obj.description = message.description;
    }
    if (message.labels?.length) {
      obj.labels = message.labels;
    }
    if (message.annotations?.length) {
      obj.annotations = message.annotations.map((e) => Annotation.toJSON(e));
    }
    if (message.enabled !== false) {
      obj.enabled = message.enabled;
    }
    if (message.metadata !== undefined) {
      obj.metadata = Metadata.toJSON(message.metadata);
    }
    if (message.index !== 0) {
      obj.index = Math.round(message.index);
    }
    if (message.breakout !== false) {
      obj.breakout = message.breakout;
    }
    if (message.breakoutIndex !== 0) {
      obj.breakoutIndex = Math.round(message.breakoutIndex);
    }
    if (message.linecard !== 0) {
      obj.linecard = Math.round(message.linecard);
    }
    if (message.vrfId !== "") {
      obj.vrfId = message.vrfId;
    }
    if (message.vlanIds?.length) {
      obj.vlanIds = message.vlanIds.map((e) => Math.round(e));
    }
    if (message.vnis?.length) {
      obj.vnis = message.vnis.map((e) => Math.round(e));
    }
    if (message.fec !== "") {
      obj.fec = message.fec;
    }
    if (message.roles?.length) {
      obj.roles = message.roles.map((e) => portRoleToJSON(e));
    }
    if (message.linkDown !== false) {
      obj.linkDown = message.linkDown;
    }
    if (message.ipv4Addresses?.length) {
      obj.ipv4Addresses = message.ipv4Addresses;
    }
    if (message.ipv6Addresses?.length) {
      obj.ipv6Addresses = message.ipv6Addresses;
    }
    if (message.subInfCount !== 0) {
      obj.subInfCount = Math.round(message.subInfCount);
    }
    if (message.stp !== undefined) {
      obj.stp = InterfaceStp.toJSON(message.stp);
    }
    if (message.tag !== 0) {
      obj.tag = routeTagToJSON(message.tag);
    }
    if (message.pluggable !== "") {
      obj.pluggable = message.pluggable;
    }
    if (message.mtu !== 0) {
      obj.mtu = Math.round(message.mtu);
    }
    if (message.maxSpeed !== "") {
      obj.maxSpeed = message.maxSpeed;
    }
    if (message.speed !== "") {
      obj.speed = message.speed;
    }
    if (message.forceCounter !== 0) {
      obj.forceCounter = Math.round(message.forceCounter);
    }
    if (message.portAlias !== "") {
      obj.portAlias = message.portAlias;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<NetworkPort>, I>>(base?: I): NetworkPort {
    return NetworkPort.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<NetworkPort>, I>>(object: I): NetworkPort {
    const message = createBaseNetworkPort();
    message.id = object.id ?? "";
    message.name = object.name ?? "";
    message.nodeId = object.nodeId ?? "";
    message.description = object.description ?? "";
    message.labels = object.labels?.map((e) => e) || [];
    message.annotations = object.annotations?.map((e) => Annotation.fromPartial(e)) || [];
    message.enabled = object.enabled ?? false;
    message.metadata = (object.metadata !== undefined && object.metadata !== null)
      ? Metadata.fromPartial(object.metadata)
      : undefined;
    message.index = object.index ?? 0;
    message.breakout = object.breakout ?? false;
    message.breakoutIndex = object.breakoutIndex ?? 0;
    message.linecard = object.linecard ?? 0;
    message.vrfId = object.vrfId ?? "";
    message.vlanIds = object.vlanIds?.map((e) => e) || [];
    message.vnis = object.vnis?.map((e) => e) || [];
    message.fec = object.fec ?? "";
    message.roles = object.roles?.map((e) => e) || [];
    message.linkDown = object.linkDown ?? false;
    message.ipv4Addresses = object.ipv4Addresses?.map((e) => e) || [];
    message.ipv6Addresses = object.ipv6Addresses?.map((e) => e) || [];
    message.subInfCount = object.subInfCount ?? 0;
    message.stp = (object.stp !== undefined && object.stp !== null) ? InterfaceStp.fromPartial(object.stp) : undefined;
    message.tag = object.tag ?? 0;
    message.pluggable = object.pluggable ?? "";
    message.mtu = object.mtu ?? 0;
    message.maxSpeed = object.maxSpeed ?? "";
    message.speed = object.speed ?? "";
    message.forceCounter = object.forceCounter ?? 0;
    message.portAlias = object.portAlias ?? "";
    return message;
  },
};

function createBaseManagementPort(): ManagementPort {
  return {
    id: "",
    nodeId: "",
    name: "",
    description: "",
    ipv4Address: "",
    ipv4Gateway: "",
    ipv6Address: "",
    ipv6Gateway: "",
    dnsAddresses: [],
    proxyAddress: "",
    proxyUsername: "",
    proxyCredentialsId: "",
    proxyPassword: "",
    enabled: false,
    connectedState: 0,
    ipv4ConfigType: 0,
    ipv6ConfigType: 0,
    ntpAddresses: [],
    cloudUrls: [],
    configOrigin: 0,
    metadata: undefined,
    setProxyPassword: false,
    loginPassword: "",
    noProxy: [],
    portType: 0,
  };
}

export const ManagementPort: MessageFns<ManagementPort> = {
  encode(message: ManagementPort, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.nodeId !== "") {
      writer.uint32(18).string(message.nodeId);
    }
    if (message.name !== "") {
      writer.uint32(26).string(message.name);
    }
    if (message.description !== "") {
      writer.uint32(34).string(message.description);
    }
    if (message.ipv4Address !== "") {
      writer.uint32(42).string(message.ipv4Address);
    }
    if (message.ipv4Gateway !== "") {
      writer.uint32(50).string(message.ipv4Gateway);
    }
    if (message.ipv6Address !== "") {
      writer.uint32(58).string(message.ipv6Address);
    }
    if (message.ipv6Gateway !== "") {
      writer.uint32(66).string(message.ipv6Gateway);
    }
    for (const v of message.dnsAddresses) {
      writer.uint32(74).string(v!);
    }
    if (message.proxyAddress !== "") {
      writer.uint32(82).string(message.proxyAddress);
    }
    if (message.proxyUsername !== "") {
      writer.uint32(90).string(message.proxyUsername);
    }
    if (message.proxyCredentialsId !== "") {
      writer.uint32(98).string(message.proxyCredentialsId);
    }
    if (message.proxyPassword !== "") {
      writer.uint32(106).string(message.proxyPassword);
    }
    if (message.enabled !== false) {
      writer.uint32(112).bool(message.enabled);
    }
    if (message.connectedState !== 0) {
      writer.uint32(120).int32(message.connectedState);
    }
    if (message.ipv4ConfigType !== 0) {
      writer.uint32(128).int32(message.ipv4ConfigType);
    }
    if (message.ipv6ConfigType !== 0) {
      writer.uint32(136).int32(message.ipv6ConfigType);
    }
    for (const v of message.ntpAddresses) {
      writer.uint32(146).string(v!);
    }
    for (const v of message.cloudUrls) {
      writer.uint32(154).string(v!);
    }
    if (message.configOrigin !== 0) {
      writer.uint32(160).int32(message.configOrigin);
    }
    if (message.metadata !== undefined) {
      Metadata.encode(message.metadata, writer.uint32(170).fork()).join();
    }
    if (message.setProxyPassword !== false) {
      writer.uint32(176).bool(message.setProxyPassword);
    }
    if (message.loginPassword !== "") {
      writer.uint32(186).string(message.loginPassword);
    }
    for (const v of message.noProxy) {
      writer.uint32(194).string(v!);
    }
    if (message.portType !== 0) {
      writer.uint32(200).int32(message.portType);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ManagementPort {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseManagementPort();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.nodeId = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.description = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.ipv4Address = reader.string();
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.ipv4Gateway = reader.string();
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.ipv6Address = reader.string();
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.ipv6Gateway = reader.string();
          continue;
        }
        case 9: {
          if (tag !== 74) {
            break;
          }

          message.dnsAddresses.push(reader.string());
          continue;
        }
        case 10: {
          if (tag !== 82) {
            break;
          }

          message.proxyAddress = reader.string();
          continue;
        }
        case 11: {
          if (tag !== 90) {
            break;
          }

          message.proxyUsername = reader.string();
          continue;
        }
        case 12: {
          if (tag !== 98) {
            break;
          }

          message.proxyCredentialsId = reader.string();
          continue;
        }
        case 13: {
          if (tag !== 106) {
            break;
          }

          message.proxyPassword = reader.string();
          continue;
        }
        case 14: {
          if (tag !== 112) {
            break;
          }

          message.enabled = reader.bool();
          continue;
        }
        case 15: {
          if (tag !== 120) {
            break;
          }

          message.connectedState = reader.int32() as any;
          continue;
        }
        case 16: {
          if (tag !== 128) {
            break;
          }

          message.ipv4ConfigType = reader.int32() as any;
          continue;
        }
        case 17: {
          if (tag !== 136) {
            break;
          }

          message.ipv6ConfigType = reader.int32() as any;
          continue;
        }
        case 18: {
          if (tag !== 146) {
            break;
          }

          message.ntpAddresses.push(reader.string());
          continue;
        }
        case 19: {
          if (tag !== 154) {
            break;
          }

          message.cloudUrls.push(reader.string());
          continue;
        }
        case 20: {
          if (tag !== 160) {
            break;
          }

          message.configOrigin = reader.int32() as any;
          continue;
        }
        case 21: {
          if (tag !== 170) {
            break;
          }

          message.metadata = Metadata.decode(reader, reader.uint32());
          continue;
        }
        case 22: {
          if (tag !== 176) {
            break;
          }

          message.setProxyPassword = reader.bool();
          continue;
        }
        case 23: {
          if (tag !== 186) {
            break;
          }

          message.loginPassword = reader.string();
          continue;
        }
        case 24: {
          if (tag !== 194) {
            break;
          }

          message.noProxy.push(reader.string());
          continue;
        }
        case 25: {
          if (tag !== 200) {
            break;
          }

          message.portType = reader.int32() as any;
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ManagementPort {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      nodeId: isSet(object.nodeId) ? globalThis.String(object.nodeId) : "",
      name: isSet(object.name) ? globalThis.String(object.name) : "",
      description: isSet(object.description) ? globalThis.String(object.description) : "",
      ipv4Address: isSet(object.ipv4Address) ? globalThis.String(object.ipv4Address) : "",
      ipv4Gateway: isSet(object.ipv4Gateway) ? globalThis.String(object.ipv4Gateway) : "",
      ipv6Address: isSet(object.ipv6Address) ? globalThis.String(object.ipv6Address) : "",
      ipv6Gateway: isSet(object.ipv6Gateway) ? globalThis.String(object.ipv6Gateway) : "",
      dnsAddresses: globalThis.Array.isArray(object?.dnsAddresses)
        ? object.dnsAddresses.map((e: any) => globalThis.String(e))
        : [],
      proxyAddress: isSet(object.proxyAddress) ? globalThis.String(object.proxyAddress) : "",
      proxyUsername: isSet(object.proxyUsername) ? globalThis.String(object.proxyUsername) : "",
      proxyCredentialsId: isSet(object.proxyCredentialsId) ? globalThis.String(object.proxyCredentialsId) : "",
      proxyPassword: isSet(object.proxyPassword) ? globalThis.String(object.proxyPassword) : "",
      enabled: isSet(object.enabled) ? globalThis.Boolean(object.enabled) : false,
      connectedState: isSet(object.connectedState) ? connectedStateFromJSON(object.connectedState) : 0,
      ipv4ConfigType: isSet(object.ipv4ConfigType) ? configTypeFromJSON(object.ipv4ConfigType) : 0,
      ipv6ConfigType: isSet(object.ipv6ConfigType) ? configTypeFromJSON(object.ipv6ConfigType) : 0,
      ntpAddresses: globalThis.Array.isArray(object?.ntpAddresses)
        ? object.ntpAddresses.map((e: any) => globalThis.String(e))
        : [],
      cloudUrls: globalThis.Array.isArray(object?.cloudUrls)
        ? object.cloudUrls.map((e: any) => globalThis.String(e))
        : [],
      configOrigin: isSet(object.configOrigin) ? configOriginFromJSON(object.configOrigin) : 0,
      metadata: isSet(object.metadata) ? Metadata.fromJSON(object.metadata) : undefined,
      setProxyPassword: isSet(object.setProxyPassword) ? globalThis.Boolean(object.setProxyPassword) : false,
      loginPassword: isSet(object.loginPassword) ? globalThis.String(object.loginPassword) : "",
      noProxy: globalThis.Array.isArray(object?.noProxy) ? object.noProxy.map((e: any) => globalThis.String(e)) : [],
      portType: isSet(object.portType) ? portTypeFromJSON(object.portType) : 0,
    };
  },

  toJSON(message: ManagementPort): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.nodeId !== "") {
      obj.nodeId = message.nodeId;
    }
    if (message.name !== "") {
      obj.name = message.name;
    }
    if (message.description !== "") {
      obj.description = message.description;
    }
    if (message.ipv4Address !== "") {
      obj.ipv4Address = message.ipv4Address;
    }
    if (message.ipv4Gateway !== "") {
      obj.ipv4Gateway = message.ipv4Gateway;
    }
    if (message.ipv6Address !== "") {
      obj.ipv6Address = message.ipv6Address;
    }
    if (message.ipv6Gateway !== "") {
      obj.ipv6Gateway = message.ipv6Gateway;
    }
    if (message.dnsAddresses?.length) {
      obj.dnsAddresses = message.dnsAddresses;
    }
    if (message.proxyAddress !== "") {
      obj.proxyAddress = message.proxyAddress;
    }
    if (message.proxyUsername !== "") {
      obj.proxyUsername = message.proxyUsername;
    }
    if (message.proxyCredentialsId !== "") {
      obj.proxyCredentialsId = message.proxyCredentialsId;
    }
    if (message.proxyPassword !== "") {
      obj.proxyPassword = message.proxyPassword;
    }
    if (message.enabled !== false) {
      obj.enabled = message.enabled;
    }
    if (message.connectedState !== 0) {
      obj.connectedState = connectedStateToJSON(message.connectedState);
    }
    if (message.ipv4ConfigType !== 0) {
      obj.ipv4ConfigType = configTypeToJSON(message.ipv4ConfigType);
    }
    if (message.ipv6ConfigType !== 0) {
      obj.ipv6ConfigType = configTypeToJSON(message.ipv6ConfigType);
    }
    if (message.ntpAddresses?.length) {
      obj.ntpAddresses = message.ntpAddresses;
    }
    if (message.cloudUrls?.length) {
      obj.cloudUrls = message.cloudUrls;
    }
    if (message.configOrigin !== 0) {
      obj.configOrigin = configOriginToJSON(message.configOrigin);
    }
    if (message.metadata !== undefined) {
      obj.metadata = Metadata.toJSON(message.metadata);
    }
    if (message.setProxyPassword !== false) {
      obj.setProxyPassword = message.setProxyPassword;
    }
    if (message.loginPassword !== "") {
      obj.loginPassword = message.loginPassword;
    }
    if (message.noProxy?.length) {
      obj.noProxy = message.noProxy;
    }
    if (message.portType !== 0) {
      obj.portType = portTypeToJSON(message.portType);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ManagementPort>, I>>(base?: I): ManagementPort {
    return ManagementPort.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ManagementPort>, I>>(object: I): ManagementPort {
    const message = createBaseManagementPort();
    message.id = object.id ?? "";
    message.nodeId = object.nodeId ?? "";
    message.name = object.name ?? "";
    message.description = object.description ?? "";
    message.ipv4Address = object.ipv4Address ?? "";
    message.ipv4Gateway = object.ipv4Gateway ?? "";
    message.ipv6Address = object.ipv6Address ?? "";
    message.ipv6Gateway = object.ipv6Gateway ?? "";
    message.dnsAddresses = object.dnsAddresses?.map((e) => e) || [];
    message.proxyAddress = object.proxyAddress ?? "";
    message.proxyUsername = object.proxyUsername ?? "";
    message.proxyCredentialsId = object.proxyCredentialsId ?? "";
    message.proxyPassword = object.proxyPassword ?? "";
    message.enabled = object.enabled ?? false;
    message.connectedState = object.connectedState ?? 0;
    message.ipv4ConfigType = object.ipv4ConfigType ?? 0;
    message.ipv6ConfigType = object.ipv6ConfigType ?? 0;
    message.ntpAddresses = object.ntpAddresses?.map((e) => e) || [];
    message.cloudUrls = object.cloudUrls?.map((e) => e) || [];
    message.configOrigin = object.configOrigin ?? 0;
    message.metadata = (object.metadata !== undefined && object.metadata !== null)
      ? Metadata.fromPartial(object.metadata)
      : undefined;
    message.setProxyPassword = object.setProxyPassword ?? false;
    message.loginPassword = object.loginPassword ?? "";
    message.noProxy = object.noProxy?.map((e) => e) || [];
    message.portType = object.portType ?? 0;
    return message;
  },
};

function createBaseServerMgmtPort(): ServerMgmtPort {
  return {
    id: "",
    nodeId: "",
    name: "",
    description: "",
    linecard: 0,
    index: 0,
    portType: 0,
    portGroupType: 0,
    macAddress: "",
    pluggable: "",
    speed: "",
    remoteNodeId: "",
    remotePort: "",
    remotePluggable: "",
    cablePid: "",
    credentialsId: "",
    ipv4Address: "",
    ipv6Address: "",
  };
}

export const ServerMgmtPort: MessageFns<ServerMgmtPort> = {
  encode(message: ServerMgmtPort, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.nodeId !== "") {
      writer.uint32(18).string(message.nodeId);
    }
    if (message.name !== "") {
      writer.uint32(26).string(message.name);
    }
    if (message.description !== "") {
      writer.uint32(34).string(message.description);
    }
    if (message.linecard !== 0) {
      writer.uint32(40).uint32(message.linecard);
    }
    if (message.index !== 0) {
      writer.uint32(48).uint32(message.index);
    }
    if (message.portType !== 0) {
      writer.uint32(56).int32(message.portType);
    }
    if (message.portGroupType !== 0) {
      writer.uint32(64).int32(message.portGroupType);
    }
    if (message.macAddress !== "") {
      writer.uint32(74).string(message.macAddress);
    }
    if (message.pluggable !== "") {
      writer.uint32(82).string(message.pluggable);
    }
    if (message.speed !== "") {
      writer.uint32(90).string(message.speed);
    }
    if (message.remoteNodeId !== "") {
      writer.uint32(98).string(message.remoteNodeId);
    }
    if (message.remotePort !== "") {
      writer.uint32(106).string(message.remotePort);
    }
    if (message.remotePluggable !== "") {
      writer.uint32(114).string(message.remotePluggable);
    }
    if (message.cablePid !== "") {
      writer.uint32(122).string(message.cablePid);
    }
    if (message.credentialsId !== "") {
      writer.uint32(130).string(message.credentialsId);
    }
    if (message.ipv4Address !== "") {
      writer.uint32(138).string(message.ipv4Address);
    }
    if (message.ipv6Address !== "") {
      writer.uint32(146).string(message.ipv6Address);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ServerMgmtPort {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseServerMgmtPort();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.nodeId = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.description = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.linecard = reader.uint32();
          continue;
        }
        case 6: {
          if (tag !== 48) {
            break;
          }

          message.index = reader.uint32();
          continue;
        }
        case 7: {
          if (tag !== 56) {
            break;
          }

          message.portType = reader.int32() as any;
          continue;
        }
        case 8: {
          if (tag !== 64) {
            break;
          }

          message.portGroupType = reader.int32() as any;
          continue;
        }
        case 9: {
          if (tag !== 74) {
            break;
          }

          message.macAddress = reader.string();
          continue;
        }
        case 10: {
          if (tag !== 82) {
            break;
          }

          message.pluggable = reader.string();
          continue;
        }
        case 11: {
          if (tag !== 90) {
            break;
          }

          message.speed = reader.string();
          continue;
        }
        case 12: {
          if (tag !== 98) {
            break;
          }

          message.remoteNodeId = reader.string();
          continue;
        }
        case 13: {
          if (tag !== 106) {
            break;
          }

          message.remotePort = reader.string();
          continue;
        }
        case 14: {
          if (tag !== 114) {
            break;
          }

          message.remotePluggable = reader.string();
          continue;
        }
        case 15: {
          if (tag !== 122) {
            break;
          }

          message.cablePid = reader.string();
          continue;
        }
        case 16: {
          if (tag !== 130) {
            break;
          }

          message.credentialsId = reader.string();
          continue;
        }
        case 17: {
          if (tag !== 138) {
            break;
          }

          message.ipv4Address = reader.string();
          continue;
        }
        case 18: {
          if (tag !== 146) {
            break;
          }

          message.ipv6Address = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ServerMgmtPort {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      nodeId: isSet(object.nodeId) ? globalThis.String(object.nodeId) : "",
      name: isSet(object.name) ? globalThis.String(object.name) : "",
      description: isSet(object.description) ? globalThis.String(object.description) : "",
      linecard: isSet(object.linecard) ? globalThis.Number(object.linecard) : 0,
      index: isSet(object.index) ? globalThis.Number(object.index) : 0,
      portType: isSet(object.portType) ? portTypeFromJSON(object.portType) : 0,
      portGroupType: isSet(object.portGroupType) ? serverPortGroupTypeFromJSON(object.portGroupType) : 0,
      macAddress: isSet(object.macAddress) ? globalThis.String(object.macAddress) : "",
      pluggable: isSet(object.pluggable) ? globalThis.String(object.pluggable) : "",
      speed: isSet(object.speed) ? globalThis.String(object.speed) : "",
      remoteNodeId: isSet(object.remoteNodeId) ? globalThis.String(object.remoteNodeId) : "",
      remotePort: isSet(object.remotePort) ? globalThis.String(object.remotePort) : "",
      remotePluggable: isSet(object.remotePluggable) ? globalThis.String(object.remotePluggable) : "",
      cablePid: isSet(object.cablePid) ? globalThis.String(object.cablePid) : "",
      credentialsId: isSet(object.credentialsId) ? globalThis.String(object.credentialsId) : "",
      ipv4Address: isSet(object.ipv4Address) ? globalThis.String(object.ipv4Address) : "",
      ipv6Address: isSet(object.ipv6Address) ? globalThis.String(object.ipv6Address) : "",
    };
  },

  toJSON(message: ServerMgmtPort): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.nodeId !== "") {
      obj.nodeId = message.nodeId;
    }
    if (message.name !== "") {
      obj.name = message.name;
    }
    if (message.description !== "") {
      obj.description = message.description;
    }
    if (message.linecard !== 0) {
      obj.linecard = Math.round(message.linecard);
    }
    if (message.index !== 0) {
      obj.index = Math.round(message.index);
    }
    if (message.portType !== 0) {
      obj.portType = portTypeToJSON(message.portType);
    }
    if (message.portGroupType !== 0) {
      obj.portGroupType = serverPortGroupTypeToJSON(message.portGroupType);
    }
    if (message.macAddress !== "") {
      obj.macAddress = message.macAddress;
    }
    if (message.pluggable !== "") {
      obj.pluggable = message.pluggable;
    }
    if (message.speed !== "") {
      obj.speed = message.speed;
    }
    if (message.remoteNodeId !== "") {
      obj.remoteNodeId = message.remoteNodeId;
    }
    if (message.remotePort !== "") {
      obj.remotePort = message.remotePort;
    }
    if (message.remotePluggable !== "") {
      obj.remotePluggable = message.remotePluggable;
    }
    if (message.cablePid !== "") {
      obj.cablePid = message.cablePid;
    }
    if (message.credentialsId !== "") {
      obj.credentialsId = message.credentialsId;
    }
    if (message.ipv4Address !== "") {
      obj.ipv4Address = message.ipv4Address;
    }
    if (message.ipv6Address !== "") {
      obj.ipv6Address = message.ipv6Address;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ServerMgmtPort>, I>>(base?: I): ServerMgmtPort {
    return ServerMgmtPort.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ServerMgmtPort>, I>>(object: I): ServerMgmtPort {
    const message = createBaseServerMgmtPort();
    message.id = object.id ?? "";
    message.nodeId = object.nodeId ?? "";
    message.name = object.name ?? "";
    message.description = object.description ?? "";
    message.linecard = object.linecard ?? 0;
    message.index = object.index ?? 0;
    message.portType = object.portType ?? 0;
    message.portGroupType = object.portGroupType ?? 0;
    message.macAddress = object.macAddress ?? "";
    message.pluggable = object.pluggable ?? "";
    message.speed = object.speed ?? "";
    message.remoteNodeId = object.remoteNodeId ?? "";
    message.remotePort = object.remotePort ?? "";
    message.remotePluggable = object.remotePluggable ?? "";
    message.cablePid = object.cablePid ?? "";
    message.credentialsId = object.credentialsId ?? "";
    message.ipv4Address = object.ipv4Address ?? "";
    message.ipv6Address = object.ipv6Address ?? "";
    return message;
  },
};

function createBaseBmcNtpConfig(): BmcNtpConfig {
  return { enabled: false, servers: [] };
}

export const BmcNtpConfig: MessageFns<BmcNtpConfig> = {
  encode(message: BmcNtpConfig, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.enabled !== false) {
      writer.uint32(8).bool(message.enabled);
    }
    for (const v of message.servers) {
      writer.uint32(18).string(v!);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): BmcNtpConfig {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseBmcNtpConfig();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.enabled = reader.bool();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.servers.push(reader.string());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): BmcNtpConfig {
    return {
      enabled: isSet(object.enabled) ? globalThis.Boolean(object.enabled) : false,
      servers: globalThis.Array.isArray(object?.servers) ? object.servers.map((e: any) => globalThis.String(e)) : [],
    };
  },

  toJSON(message: BmcNtpConfig): unknown {
    const obj: any = {};
    if (message.enabled !== false) {
      obj.enabled = message.enabled;
    }
    if (message.servers?.length) {
      obj.servers = message.servers;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<BmcNtpConfig>, I>>(base?: I): BmcNtpConfig {
    return BmcNtpConfig.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<BmcNtpConfig>, I>>(object: I): BmcNtpConfig {
    const message = createBaseBmcNtpConfig();
    message.enabled = object.enabled ?? false;
    message.servers = object.servers?.map((e) => e) || [];
    return message;
  },
};

function createBaseBmcConfig(): BmcConfig {
  return {
    id: "",
    name: "",
    description: "",
    labels: [],
    annotations: [],
    enabled: false,
    metadata: undefined,
    fabricId: "",
    nodeId: "",
    portGroupType: 0,
    slotNumber: 0,
    ntp: undefined,
  };
}

export const BmcConfig: MessageFns<BmcConfig> = {
  encode(message: BmcConfig, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.name !== "") {
      writer.uint32(18).string(message.name);
    }
    if (message.description !== "") {
      writer.uint32(26).string(message.description);
    }
    for (const v of message.labels) {
      writer.uint32(34).string(v!);
    }
    for (const v of message.annotations) {
      Annotation.encode(v!, writer.uint32(42).fork()).join();
    }
    if (message.enabled !== false) {
      writer.uint32(48).bool(message.enabled);
    }
    if (message.metadata !== undefined) {
      Metadata.encode(message.metadata, writer.uint32(58).fork()).join();
    }
    if (message.fabricId !== "") {
      writer.uint32(74).string(message.fabricId);
    }
    if (message.nodeId !== "") {
      writer.uint32(82).string(message.nodeId);
    }
    if (message.portGroupType !== 0) {
      writer.uint32(88).int32(message.portGroupType);
    }
    if (message.slotNumber !== 0) {
      writer.uint32(96).uint32(message.slotNumber);
    }
    if (message.ntp !== undefined) {
      BmcNtpConfig.encode(message.ntp, writer.uint32(162).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): BmcConfig {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseBmcConfig();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.description = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.labels.push(reader.string());
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.annotations.push(Annotation.decode(reader, reader.uint32()));
          continue;
        }
        case 6: {
          if (tag !== 48) {
            break;
          }

          message.enabled = reader.bool();
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.metadata = Metadata.decode(reader, reader.uint32());
          continue;
        }
        case 9: {
          if (tag !== 74) {
            break;
          }

          message.fabricId = reader.string();
          continue;
        }
        case 10: {
          if (tag !== 82) {
            break;
          }

          message.nodeId = reader.string();
          continue;
        }
        case 11: {
          if (tag !== 88) {
            break;
          }

          message.portGroupType = reader.int32() as any;
          continue;
        }
        case 12: {
          if (tag !== 96) {
            break;
          }

          message.slotNumber = reader.uint32();
          continue;
        }
        case 20: {
          if (tag !== 162) {
            break;
          }

          message.ntp = BmcNtpConfig.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): BmcConfig {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      name: isSet(object.name) ? globalThis.String(object.name) : "",
      description: isSet(object.description) ? globalThis.String(object.description) : "",
      labels: globalThis.Array.isArray(object?.labels) ? object.labels.map((e: any) => globalThis.String(e)) : [],
      annotations: globalThis.Array.isArray(object?.annotations)
        ? object.annotations.map((e: any) => Annotation.fromJSON(e))
        : [],
      enabled: isSet(object.enabled) ? globalThis.Boolean(object.enabled) : false,
      metadata: isSet(object.metadata) ? Metadata.fromJSON(object.metadata) : undefined,
      fabricId: isSet(object.fabricId) ? globalThis.String(object.fabricId) : "",
      nodeId: isSet(object.nodeId) ? globalThis.String(object.nodeId) : "",
      portGroupType: isSet(object.portGroupType) ? serverPortGroupTypeFromJSON(object.portGroupType) : 0,
      slotNumber: isSet(object.slotNumber) ? globalThis.Number(object.slotNumber) : 0,
      ntp: isSet(object.ntp) ? BmcNtpConfig.fromJSON(object.ntp) : undefined,
    };
  },

  toJSON(message: BmcConfig): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.name !== "") {
      obj.name = message.name;
    }
    if (message.description !== "") {
      obj.description = message.description;
    }
    if (message.labels?.length) {
      obj.labels = message.labels;
    }
    if (message.annotations?.length) {
      obj.annotations = message.annotations.map((e) => Annotation.toJSON(e));
    }
    if (message.enabled !== false) {
      obj.enabled = message.enabled;
    }
    if (message.metadata !== undefined) {
      obj.metadata = Metadata.toJSON(message.metadata);
    }
    if (message.fabricId !== "") {
      obj.fabricId = message.fabricId;
    }
    if (message.nodeId !== "") {
      obj.nodeId = message.nodeId;
    }
    if (message.portGroupType !== 0) {
      obj.portGroupType = serverPortGroupTypeToJSON(message.portGroupType);
    }
    if (message.slotNumber !== 0) {
      obj.slotNumber = Math.round(message.slotNumber);
    }
    if (message.ntp !== undefined) {
      obj.ntp = BmcNtpConfig.toJSON(message.ntp);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<BmcConfig>, I>>(base?: I): BmcConfig {
    return BmcConfig.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<BmcConfig>, I>>(object: I): BmcConfig {
    const message = createBaseBmcConfig();
    message.id = object.id ?? "";
    message.name = object.name ?? "";
    message.description = object.description ?? "";
    message.labels = object.labels?.map((e) => e) || [];
    message.annotations = object.annotations?.map((e) => Annotation.fromPartial(e)) || [];
    message.enabled = object.enabled ?? false;
    message.metadata = (object.metadata !== undefined && object.metadata !== null)
      ? Metadata.fromPartial(object.metadata)
      : undefined;
    message.fabricId = object.fabricId ?? "";
    message.nodeId = object.nodeId ?? "";
    message.portGroupType = object.portGroupType ?? 0;
    message.slotNumber = object.slotNumber ?? 0;
    message.ntp = (object.ntp !== undefined && object.ntp !== null) ? BmcNtpConfig.fromPartial(object.ntp) : undefined;
    return message;
  },
};

function createBasePortChannel(): PortChannel {
  return {
    id: "",
    name: "",
    description: "",
    labels: [],
    annotations: [],
    enabled: false,
    metadata: undefined,
    fabricId: "",
    roles: [],
    members: [],
    lacpMode: 0,
    mtu: 0,
    minLinks: 0,
    ipv4Addresses: [],
    ipv6Addresses: [],
    sysMac: "",
    stp: undefined,
    vrfId: "",
    vlanIds: [],
    vnis: [],
    maxSpeed: "",
  };
}

export const PortChannel: MessageFns<PortChannel> = {
  encode(message: PortChannel, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.name !== "") {
      writer.uint32(18).string(message.name);
    }
    if (message.description !== "") {
      writer.uint32(26).string(message.description);
    }
    for (const v of message.labels) {
      writer.uint32(34).string(v!);
    }
    for (const v of message.annotations) {
      Annotation.encode(v!, writer.uint32(42).fork()).join();
    }
    if (message.enabled !== false) {
      writer.uint32(48).bool(message.enabled);
    }
    if (message.metadata !== undefined) {
      Metadata.encode(message.metadata, writer.uint32(58).fork()).join();
    }
    if (message.fabricId !== "") {
      writer.uint32(74).string(message.fabricId);
    }
    writer.uint32(82).fork();
    for (const v of message.roles) {
      writer.int32(v);
    }
    writer.join();
    for (const v of message.members) {
      PortEndpoint.encode(v!, writer.uint32(90).fork()).join();
    }
    if (message.lacpMode !== 0) {
      writer.uint32(96).int32(message.lacpMode);
    }
    if (message.mtu !== 0) {
      writer.uint32(104).uint32(message.mtu);
    }
    if (message.minLinks !== 0) {
      writer.uint32(112).uint32(message.minLinks);
    }
    for (const v of message.ipv4Addresses) {
      writer.uint32(122).string(v!);
    }
    for (const v of message.ipv6Addresses) {
      writer.uint32(130).string(v!);
    }
    if (message.sysMac !== "") {
      writer.uint32(138).string(message.sysMac);
    }
    if (message.stp !== undefined) {
      InterfaceStp.encode(message.stp, writer.uint32(202).fork()).join();
    }
    if (message.vrfId !== "") {
      writer.uint32(162).string(message.vrfId);
    }
    writer.uint32(170).fork();
    for (const v of message.vlanIds) {
      writer.uint32(v);
    }
    writer.join();
    writer.uint32(178).fork();
    for (const v of message.vnis) {
      writer.uint32(v);
    }
    writer.join();
    if (message.maxSpeed !== "") {
      writer.uint32(186).string(message.maxSpeed);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): PortChannel {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePortChannel();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.description = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.labels.push(reader.string());
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.annotations.push(Annotation.decode(reader, reader.uint32()));
          continue;
        }
        case 6: {
          if (tag !== 48) {
            break;
          }

          message.enabled = reader.bool();
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.metadata = Metadata.decode(reader, reader.uint32());
          continue;
        }
        case 9: {
          if (tag !== 74) {
            break;
          }

          message.fabricId = reader.string();
          continue;
        }
        case 10: {
          if (tag === 80) {
            message.roles.push(reader.int32() as any);

            continue;
          }

          if (tag === 82) {
            const end2 = reader.uint32() + reader.pos;
            while (reader.pos < end2) {
              message.roles.push(reader.int32() as any);
            }

            continue;
          }

          break;
        }
        case 11: {
          if (tag !== 90) {
            break;
          }

          message.members.push(PortEndpoint.decode(reader, reader.uint32()));
          continue;
        }
        case 12: {
          if (tag !== 96) {
            break;
          }

          message.lacpMode = reader.int32() as any;
          continue;
        }
        case 13: {
          if (tag !== 104) {
            break;
          }

          message.mtu = reader.uint32();
          continue;
        }
        case 14: {
          if (tag !== 112) {
            break;
          }

          message.minLinks = reader.uint32();
          continue;
        }
        case 15: {
          if (tag !== 122) {
            break;
          }

          message.ipv4Addresses.push(reader.string());
          continue;
        }
        case 16: {
          if (tag !== 130) {
            break;
          }

          message.ipv6Addresses.push(reader.string());
          continue;
        }
        case 17: {
          if (tag !== 138) {
            break;
          }

          message.sysMac = reader.string();
          continue;
        }
        case 25: {
          if (tag !== 202) {
            break;
          }

          message.stp = InterfaceStp.decode(reader, reader.uint32());
          continue;
        }
        case 20: {
          if (tag !== 162) {
            break;
          }

          message.vrfId = reader.string();
          continue;
        }
        case 21: {
          if (tag === 168) {
            message.vlanIds.push(reader.uint32());

            continue;
          }

          if (tag === 170) {
            const end2 = reader.uint32() + reader.pos;
            while (reader.pos < end2) {
              message.vlanIds.push(reader.uint32());
            }

            continue;
          }

          break;
        }
        case 22: {
          if (tag === 176) {
            message.vnis.push(reader.uint32());

            continue;
          }

          if (tag === 178) {
            const end2 = reader.uint32() + reader.pos;
            while (reader.pos < end2) {
              message.vnis.push(reader.uint32());
            }

            continue;
          }

          break;
        }
        case 23: {
          if (tag !== 186) {
            break;
          }

          message.maxSpeed = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): PortChannel {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      name: isSet(object.name) ? globalThis.String(object.name) : "",
      description: isSet(object.description) ? globalThis.String(object.description) : "",
      labels: globalThis.Array.isArray(object?.labels) ? object.labels.map((e: any) => globalThis.String(e)) : [],
      annotations: globalThis.Array.isArray(object?.annotations)
        ? object.annotations.map((e: any) => Annotation.fromJSON(e))
        : [],
      enabled: isSet(object.enabled) ? globalThis.Boolean(object.enabled) : false,
      metadata: isSet(object.metadata) ? Metadata.fromJSON(object.metadata) : undefined,
      fabricId: isSet(object.fabricId) ? globalThis.String(object.fabricId) : "",
      roles: globalThis.Array.isArray(object?.roles) ? object.roles.map((e: any) => portRoleFromJSON(e)) : [],
      members: globalThis.Array.isArray(object?.members)
        ? object.members.map((e: any) => PortEndpoint.fromJSON(e))
        : [],
      lacpMode: isSet(object.lacpMode) ? lacpModeFromJSON(object.lacpMode) : 0,
      mtu: isSet(object.mtu) ? globalThis.Number(object.mtu) : 0,
      minLinks: isSet(object.minLinks) ? globalThis.Number(object.minLinks) : 0,
      ipv4Addresses: globalThis.Array.isArray(object?.ipv4Addresses)
        ? object.ipv4Addresses.map((e: any) => globalThis.String(e))
        : [],
      ipv6Addresses: globalThis.Array.isArray(object?.ipv6Addresses)
        ? object.ipv6Addresses.map((e: any) => globalThis.String(e))
        : [],
      sysMac: isSet(object.sysMac) ? globalThis.String(object.sysMac) : "",
      stp: isSet(object.stp) ? InterfaceStp.fromJSON(object.stp) : undefined,
      vrfId: isSet(object.vrfId) ? globalThis.String(object.vrfId) : "",
      vlanIds: globalThis.Array.isArray(object?.vlanIds) ? object.vlanIds.map((e: any) => globalThis.Number(e)) : [],
      vnis: globalThis.Array.isArray(object?.vnis) ? object.vnis.map((e: any) => globalThis.Number(e)) : [],
      maxSpeed: isSet(object.maxSpeed) ? globalThis.String(object.maxSpeed) : "",
    };
  },

  toJSON(message: PortChannel): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.name !== "") {
      obj.name = message.name;
    }
    if (message.description !== "") {
      obj.description = message.description;
    }
    if (message.labels?.length) {
      obj.labels = message.labels;
    }
    if (message.annotations?.length) {
      obj.annotations = message.annotations.map((e) => Annotation.toJSON(e));
    }
    if (message.enabled !== false) {
      obj.enabled = message.enabled;
    }
    if (message.metadata !== undefined) {
      obj.metadata = Metadata.toJSON(message.metadata);
    }
    if (message.fabricId !== "") {
      obj.fabricId = message.fabricId;
    }
    if (message.roles?.length) {
      obj.roles = message.roles.map((e) => portRoleToJSON(e));
    }
    if (message.members?.length) {
      obj.members = message.members.map((e) => PortEndpoint.toJSON(e));
    }
    if (message.lacpMode !== 0) {
      obj.lacpMode = lacpModeToJSON(message.lacpMode);
    }
    if (message.mtu !== 0) {
      obj.mtu = Math.round(message.mtu);
    }
    if (message.minLinks !== 0) {
      obj.minLinks = Math.round(message.minLinks);
    }
    if (message.ipv4Addresses?.length) {
      obj.ipv4Addresses = message.ipv4Addresses;
    }
    if (message.ipv6Addresses?.length) {
      obj.ipv6Addresses = message.ipv6Addresses;
    }
    if (message.sysMac !== "") {
      obj.sysMac = message.sysMac;
    }
    if (message.stp !== undefined) {
      obj.stp = InterfaceStp.toJSON(message.stp);
    }
    if (message.vrfId !== "") {
      obj.vrfId = message.vrfId;
    }
    if (message.vlanIds?.length) {
      obj.vlanIds = message.vlanIds.map((e) => Math.round(e));
    }
    if (message.vnis?.length) {
      obj.vnis = message.vnis.map((e) => Math.round(e));
    }
    if (message.maxSpeed !== "") {
      obj.maxSpeed = message.maxSpeed;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<PortChannel>, I>>(base?: I): PortChannel {
    return PortChannel.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<PortChannel>, I>>(object: I): PortChannel {
    const message = createBasePortChannel();
    message.id = object.id ?? "";
    message.name = object.name ?? "";
    message.description = object.description ?? "";
    message.labels = object.labels?.map((e) => e) || [];
    message.annotations = object.annotations?.map((e) => Annotation.fromPartial(e)) || [];
    message.enabled = object.enabled ?? false;
    message.metadata = (object.metadata !== undefined && object.metadata !== null)
      ? Metadata.fromPartial(object.metadata)
      : undefined;
    message.fabricId = object.fabricId ?? "";
    message.roles = object.roles?.map((e) => e) || [];
    message.members = object.members?.map((e) => PortEndpoint.fromPartial(e)) || [];
    message.lacpMode = object.lacpMode ?? 0;
    message.mtu = object.mtu ?? 0;
    message.minLinks = object.minLinks ?? 0;
    message.ipv4Addresses = object.ipv4Addresses?.map((e) => e) || [];
    message.ipv6Addresses = object.ipv6Addresses?.map((e) => e) || [];
    message.sysMac = object.sysMac ?? "";
    message.stp = (object.stp !== undefined && object.stp !== null) ? InterfaceStp.fromPartial(object.stp) : undefined;
    message.vrfId = object.vrfId ?? "";
    message.vlanIds = object.vlanIds?.map((e) => e) || [];
    message.vnis = object.vnis?.map((e) => e) || [];
    message.maxSpeed = object.maxSpeed ?? "";
    return message;
  },
};

function createBaseSubInterface(): SubInterface {
  return {
    id: "",
    name: "",
    description: "",
    labels: [],
    annotations: [],
    enabled: false,
    metadata: undefined,
    fabricId: "",
    nodeId: "",
    vlanId: 0,
    vrfId: "",
    parent: "",
    ipv4Addresses: [],
    ipv6Addresses: [],
    tag: 0,
  };
}

export const SubInterface: MessageFns<SubInterface> = {
  encode(message: SubInterface, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.name !== "") {
      writer.uint32(18).string(message.name);
    }
    if (message.description !== "") {
      writer.uint32(26).string(message.description);
    }
    for (const v of message.labels) {
      writer.uint32(34).string(v!);
    }
    for (const v of message.annotations) {
      Annotation.encode(v!, writer.uint32(42).fork()).join();
    }
    if (message.enabled !== false) {
      writer.uint32(48).bool(message.enabled);
    }
    if (message.metadata !== undefined) {
      Metadata.encode(message.metadata, writer.uint32(58).fork()).join();
    }
    if (message.fabricId !== "") {
      writer.uint32(74).string(message.fabricId);
    }
    if (message.nodeId !== "") {
      writer.uint32(82).string(message.nodeId);
    }
    if (message.vlanId !== 0) {
      writer.uint32(88).uint32(message.vlanId);
    }
    if (message.vrfId !== "") {
      writer.uint32(98).string(message.vrfId);
    }
    if (message.parent !== "") {
      writer.uint32(106).string(message.parent);
    }
    for (const v of message.ipv4Addresses) {
      writer.uint32(122).string(v!);
    }
    for (const v of message.ipv6Addresses) {
      writer.uint32(130).string(v!);
    }
    if (message.tag !== 0) {
      writer.uint32(136).int32(message.tag);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SubInterface {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSubInterface();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.description = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.labels.push(reader.string());
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.annotations.push(Annotation.decode(reader, reader.uint32()));
          continue;
        }
        case 6: {
          if (tag !== 48) {
            break;
          }

          message.enabled = reader.bool();
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.metadata = Metadata.decode(reader, reader.uint32());
          continue;
        }
        case 9: {
          if (tag !== 74) {
            break;
          }

          message.fabricId = reader.string();
          continue;
        }
        case 10: {
          if (tag !== 82) {
            break;
          }

          message.nodeId = reader.string();
          continue;
        }
        case 11: {
          if (tag !== 88) {
            break;
          }

          message.vlanId = reader.uint32();
          continue;
        }
        case 12: {
          if (tag !== 98) {
            break;
          }

          message.vrfId = reader.string();
          continue;
        }
        case 13: {
          if (tag !== 106) {
            break;
          }

          message.parent = reader.string();
          continue;
        }
        case 15: {
          if (tag !== 122) {
            break;
          }

          message.ipv4Addresses.push(reader.string());
          continue;
        }
        case 16: {
          if (tag !== 130) {
            break;
          }

          message.ipv6Addresses.push(reader.string());
          continue;
        }
        case 17: {
          if (tag !== 136) {
            break;
          }

          message.tag = reader.int32() as any;
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SubInterface {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      name: isSet(object.name) ? globalThis.String(object.name) : "",
      description: isSet(object.description) ? globalThis.String(object.description) : "",
      labels: globalThis.Array.isArray(object?.labels) ? object.labels.map((e: any) => globalThis.String(e)) : [],
      annotations: globalThis.Array.isArray(object?.annotations)
        ? object.annotations.map((e: any) => Annotation.fromJSON(e))
        : [],
      enabled: isSet(object.enabled) ? globalThis.Boolean(object.enabled) : false,
      metadata: isSet(object.metadata) ? Metadata.fromJSON(object.metadata) : undefined,
      fabricId: isSet(object.fabricId) ? globalThis.String(object.fabricId) : "",
      nodeId: isSet(object.nodeId) ? globalThis.String(object.nodeId) : "",
      vlanId: isSet(object.vlanId) ? globalThis.Number(object.vlanId) : 0,
      vrfId: isSet(object.vrfId) ? globalThis.String(object.vrfId) : "",
      parent: isSet(object.parent) ? globalThis.String(object.parent) : "",
      ipv4Addresses: globalThis.Array.isArray(object?.ipv4Addresses)
        ? object.ipv4Addresses.map((e: any) => globalThis.String(e))
        : [],
      ipv6Addresses: globalThis.Array.isArray(object?.ipv6Addresses)
        ? object.ipv6Addresses.map((e: any) => globalThis.String(e))
        : [],
      tag: isSet(object.tag) ? routeTagFromJSON(object.tag) : 0,
    };
  },

  toJSON(message: SubInterface): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.name !== "") {
      obj.name = message.name;
    }
    if (message.description !== "") {
      obj.description = message.description;
    }
    if (message.labels?.length) {
      obj.labels = message.labels;
    }
    if (message.annotations?.length) {
      obj.annotations = message.annotations.map((e) => Annotation.toJSON(e));
    }
    if (message.enabled !== false) {
      obj.enabled = message.enabled;
    }
    if (message.metadata !== undefined) {
      obj.metadata = Metadata.toJSON(message.metadata);
    }
    if (message.fabricId !== "") {
      obj.fabricId = message.fabricId;
    }
    if (message.nodeId !== "") {
      obj.nodeId = message.nodeId;
    }
    if (message.vlanId !== 0) {
      obj.vlanId = Math.round(message.vlanId);
    }
    if (message.vrfId !== "") {
      obj.vrfId = message.vrfId;
    }
    if (message.parent !== "") {
      obj.parent = message.parent;
    }
    if (message.ipv4Addresses?.length) {
      obj.ipv4Addresses = message.ipv4Addresses;
    }
    if (message.ipv6Addresses?.length) {
      obj.ipv6Addresses = message.ipv6Addresses;
    }
    if (message.tag !== 0) {
      obj.tag = routeTagToJSON(message.tag);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<SubInterface>, I>>(base?: I): SubInterface {
    return SubInterface.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SubInterface>, I>>(object: I): SubInterface {
    const message = createBaseSubInterface();
    message.id = object.id ?? "";
    message.name = object.name ?? "";
    message.description = object.description ?? "";
    message.labels = object.labels?.map((e) => e) || [];
    message.annotations = object.annotations?.map((e) => Annotation.fromPartial(e)) || [];
    message.enabled = object.enabled ?? false;
    message.metadata = (object.metadata !== undefined && object.metadata !== null)
      ? Metadata.fromPartial(object.metadata)
      : undefined;
    message.fabricId = object.fabricId ?? "";
    message.nodeId = object.nodeId ?? "";
    message.vlanId = object.vlanId ?? 0;
    message.vrfId = object.vrfId ?? "";
    message.parent = object.parent ?? "";
    message.ipv4Addresses = object.ipv4Addresses?.map((e) => e) || [];
    message.ipv6Addresses = object.ipv6Addresses?.map((e) => e) || [];
    message.tag = object.tag ?? 0;
    return message;
  },
};

function createBaseNode(): Node {
  return {
    id: "",
    name: "",
    description: "",
    labels: [],
    annotations: [],
    enabled: false,
    metadata: undefined,
    serialNumber: "",
    modelName: "",
    osType: 0,
    nodeType: 0,
    position: 0,
    fabricId: "",
    deviceId: "",
    location: "",
    roles: [],
    ports: [],
    connections: [],
    managementPorts: [],
    breakouts: [],
    psuAirflows: [],
    hwSetId: "",
    groupId: "",
    hwSetNodePosition: 0,
    serverMgmtPorts: [],
    parentId: "",
    trayId: 0,
    trayDeviceId: "",
    bmcConfigs: [],
  };
}

export const Node: MessageFns<Node> = {
  encode(message: Node, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.name !== "") {
      writer.uint32(18).string(message.name);
    }
    if (message.description !== "") {
      writer.uint32(26).string(message.description);
    }
    for (const v of message.labels) {
      writer.uint32(34).string(v!);
    }
    for (const v of message.annotations) {
      Annotation.encode(v!, writer.uint32(42).fork()).join();
    }
    if (message.enabled !== false) {
      writer.uint32(48).bool(message.enabled);
    }
    if (message.metadata !== undefined) {
      Metadata.encode(message.metadata, writer.uint32(58).fork()).join();
    }
    if (message.serialNumber !== "") {
      writer.uint32(82).string(message.serialNumber);
    }
    if (message.modelName !== "") {
      writer.uint32(90).string(message.modelName);
    }
    if (message.osType !== 0) {
      writer.uint32(96).int32(message.osType);
    }
    if (message.nodeType !== 0) {
      writer.uint32(104).int32(message.nodeType);
    }
    if (message.position !== 0) {
      writer.uint32(112).uint32(message.position);
    }
    if (message.fabricId !== "") {
      writer.uint32(122).string(message.fabricId);
    }
    if (message.deviceId !== "") {
      writer.uint32(130).string(message.deviceId);
    }
    if (message.location !== "") {
      writer.uint32(138).string(message.location);
    }
    writer.uint32(162).fork();
    for (const v of message.roles) {
      writer.int32(v);
    }
    writer.join();
    for (const v of message.ports) {
      NetworkPort.encode(v!, writer.uint32(170).fork()).join();
    }
    for (const v of message.connections) {
      PortConnection.encode(v!, writer.uint32(178).fork()).join();
    }
    for (const v of message.managementPorts) {
      ManagementPort.encode(v!, writer.uint32(186).fork()).join();
    }
    for (const v of message.breakouts) {
      PortBreakout.encode(v!, writer.uint32(202).fork()).join();
    }
    for (const v of message.psuAirflows) {
      PsuAirflow.encode(v!, writer.uint32(210).fork()).join();
    }
    if (message.hwSetId !== "") {
      writer.uint32(218).string(message.hwSetId);
    }
    if (message.groupId !== "") {
      writer.uint32(226).string(message.groupId);
    }
    if (message.hwSetNodePosition !== 0) {
      writer.uint32(232).uint32(message.hwSetNodePosition);
    }
    for (const v of message.serverMgmtPorts) {
      ServerMgmtPort.encode(v!, writer.uint32(242).fork()).join();
    }
    if (message.parentId !== "") {
      writer.uint32(250).string(message.parentId);
    }
    if (message.trayId !== 0) {
      writer.uint32(256).uint32(message.trayId);
    }
    if (message.trayDeviceId !== "") {
      writer.uint32(266).string(message.trayDeviceId);
    }
    for (const v of message.bmcConfigs) {
      BmcConfig.encode(v!, writer.uint32(274).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Node {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseNode();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.description = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.labels.push(reader.string());
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.annotations.push(Annotation.decode(reader, reader.uint32()));
          continue;
        }
        case 6: {
          if (tag !== 48) {
            break;
          }

          message.enabled = reader.bool();
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.metadata = Metadata.decode(reader, reader.uint32());
          continue;
        }
        case 10: {
          if (tag !== 82) {
            break;
          }

          message.serialNumber = reader.string();
          continue;
        }
        case 11: {
          if (tag !== 90) {
            break;
          }

          message.modelName = reader.string();
          continue;
        }
        case 12: {
          if (tag !== 96) {
            break;
          }

          message.osType = reader.int32() as any;
          continue;
        }
        case 13: {
          if (tag !== 104) {
            break;
          }

          message.nodeType = reader.int32() as any;
          continue;
        }
        case 14: {
          if (tag !== 112) {
            break;
          }

          message.position = reader.uint32();
          continue;
        }
        case 15: {
          if (tag !== 122) {
            break;
          }

          message.fabricId = reader.string();
          continue;
        }
        case 16: {
          if (tag !== 130) {
            break;
          }

          message.deviceId = reader.string();
          continue;
        }
        case 17: {
          if (tag !== 138) {
            break;
          }

          message.location = reader.string();
          continue;
        }
        case 20: {
          if (tag === 160) {
            message.roles.push(reader.int32() as any);

            continue;
          }

          if (tag === 162) {
            const end2 = reader.uint32() + reader.pos;
            while (reader.pos < end2) {
              message.roles.push(reader.int32() as any);
            }

            continue;
          }

          break;
        }
        case 21: {
          if (tag !== 170) {
            break;
          }

          message.ports.push(NetworkPort.decode(reader, reader.uint32()));
          continue;
        }
        case 22: {
          if (tag !== 178) {
            break;
          }

          message.connections.push(PortConnection.decode(reader, reader.uint32()));
          continue;
        }
        case 23: {
          if (tag !== 186) {
            break;
          }

          message.managementPorts.push(ManagementPort.decode(reader, reader.uint32()));
          continue;
        }
        case 25: {
          if (tag !== 202) {
            break;
          }

          message.breakouts.push(PortBreakout.decode(reader, reader.uint32()));
          continue;
        }
        case 26: {
          if (tag !== 210) {
            break;
          }

          message.psuAirflows.push(PsuAirflow.decode(reader, reader.uint32()));
          continue;
        }
        case 27: {
          if (tag !== 218) {
            break;
          }

          message.hwSetId = reader.string();
          continue;
        }
        case 28: {
          if (tag !== 226) {
            break;
          }

          message.groupId = reader.string();
          continue;
        }
        case 29: {
          if (tag !== 232) {
            break;
          }

          message.hwSetNodePosition = reader.uint32();
          continue;
        }
        case 30: {
          if (tag !== 242) {
            break;
          }

          message.serverMgmtPorts.push(ServerMgmtPort.decode(reader, reader.uint32()));
          continue;
        }
        case 31: {
          if (tag !== 250) {
            break;
          }

          message.parentId = reader.string();
          continue;
        }
        case 32: {
          if (tag !== 256) {
            break;
          }

          message.trayId = reader.uint32();
          continue;
        }
        case 33: {
          if (tag !== 266) {
            break;
          }

          message.trayDeviceId = reader.string();
          continue;
        }
        case 34: {
          if (tag !== 274) {
            break;
          }

          message.bmcConfigs.push(BmcConfig.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): Node {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      name: isSet(object.name) ? globalThis.String(object.name) : "",
      description: isSet(object.description) ? globalThis.String(object.description) : "",
      labels: globalThis.Array.isArray(object?.labels) ? object.labels.map((e: any) => globalThis.String(e)) : [],
      annotations: globalThis.Array.isArray(object?.annotations)
        ? object.annotations.map((e: any) => Annotation.fromJSON(e))
        : [],
      enabled: isSet(object.enabled) ? globalThis.Boolean(object.enabled) : false,
      metadata: isSet(object.metadata) ? Metadata.fromJSON(object.metadata) : undefined,
      serialNumber: isSet(object.serialNumber) ? globalThis.String(object.serialNumber) : "",
      modelName: isSet(object.modelName) ? globalThis.String(object.modelName) : "",
      osType: isSet(object.osType) ? osTypeFromJSON(object.osType) : 0,
      nodeType: isSet(object.nodeType) ? nodeTypeFromJSON(object.nodeType) : 0,
      position: isSet(object.position) ? globalThis.Number(object.position) : 0,
      fabricId: isSet(object.fabricId) ? globalThis.String(object.fabricId) : "",
      deviceId: isSet(object.deviceId) ? globalThis.String(object.deviceId) : "",
      location: isSet(object.location) ? globalThis.String(object.location) : "",
      roles: globalThis.Array.isArray(object?.roles) ? object.roles.map((e: any) => nodeRoleFromJSON(e)) : [],
      ports: globalThis.Array.isArray(object?.ports) ? object.ports.map((e: any) => NetworkPort.fromJSON(e)) : [],
      connections: globalThis.Array.isArray(object?.connections)
        ? object.connections.map((e: any) => PortConnection.fromJSON(e))
        : [],
      managementPorts: globalThis.Array.isArray(object?.managementPorts)
        ? object.managementPorts.map((e: any) => ManagementPort.fromJSON(e))
        : [],
      breakouts: globalThis.Array.isArray(object?.breakouts)
        ? object.breakouts.map((e: any) => PortBreakout.fromJSON(e))
        : [],
      psuAirflows: globalThis.Array.isArray(object?.psuAirflows)
        ? object.psuAirflows.map((e: any) => PsuAirflow.fromJSON(e))
        : [],
      hwSetId: isSet(object.hwSetId) ? globalThis.String(object.hwSetId) : "",
      groupId: isSet(object.groupId) ? globalThis.String(object.groupId) : "",
      hwSetNodePosition: isSet(object.hwSetNodePosition) ? globalThis.Number(object.hwSetNodePosition) : 0,
      serverMgmtPorts: globalThis.Array.isArray(object?.serverMgmtPorts)
        ? object.serverMgmtPorts.map((e: any) => ServerMgmtPort.fromJSON(e))
        : [],
      parentId: isSet(object.parentId) ? globalThis.String(object.parentId) : "",
      trayId: isSet(object.trayId) ? globalThis.Number(object.trayId) : 0,
      trayDeviceId: isSet(object.trayDeviceId) ? globalThis.String(object.trayDeviceId) : "",
      bmcConfigs: globalThis.Array.isArray(object?.bmcConfigs)
        ? object.bmcConfigs.map((e: any) => BmcConfig.fromJSON(e))
        : [],
    };
  },

  toJSON(message: Node): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.name !== "") {
      obj.name = message.name;
    }
    if (message.description !== "") {
      obj.description = message.description;
    }
    if (message.labels?.length) {
      obj.labels = message.labels;
    }
    if (message.annotations?.length) {
      obj.annotations = message.annotations.map((e) => Annotation.toJSON(e));
    }
    if (message.enabled !== false) {
      obj.enabled = message.enabled;
    }
    if (message.metadata !== undefined) {
      obj.metadata = Metadata.toJSON(message.metadata);
    }
    if (message.serialNumber !== "") {
      obj.serialNumber = message.serialNumber;
    }
    if (message.modelName !== "") {
      obj.modelName = message.modelName;
    }
    if (message.osType !== 0) {
      obj.osType = osTypeToJSON(message.osType);
    }
    if (message.nodeType !== 0) {
      obj.nodeType = nodeTypeToJSON(message.nodeType);
    }
    if (message.position !== 0) {
      obj.position = Math.round(message.position);
    }
    if (message.fabricId !== "") {
      obj.fabricId = message.fabricId;
    }
    if (message.deviceId !== "") {
      obj.deviceId = message.deviceId;
    }
    if (message.location !== "") {
      obj.location = message.location;
    }
    if (message.roles?.length) {
      obj.roles = message.roles.map((e) => nodeRoleToJSON(e));
    }
    if (message.ports?.length) {
      obj.ports = message.ports.map((e) => NetworkPort.toJSON(e));
    }
    if (message.connections?.length) {
      obj.connections = message.connections.map((e) => PortConnection.toJSON(e));
    }
    if (message.managementPorts?.length) {
      obj.managementPorts = message.managementPorts.map((e) => ManagementPort.toJSON(e));
    }
    if (message.breakouts?.length) {
      obj.breakouts = message.breakouts.map((e) => PortBreakout.toJSON(e));
    }
    if (message.psuAirflows?.length) {
      obj.psuAirflows = message.psuAirflows.map((e) => PsuAirflow.toJSON(e));
    }
    if (message.hwSetId !== "") {
      obj.hwSetId = message.hwSetId;
    }
    if (message.groupId !== "") {
      obj.groupId = message.groupId;
    }
    if (message.hwSetNodePosition !== 0) {
      obj.hwSetNodePosition = Math.round(message.hwSetNodePosition);
    }
    if (message.serverMgmtPorts?.length) {
      obj.serverMgmtPorts = message.serverMgmtPorts.map((e) => ServerMgmtPort.toJSON(e));
    }
    if (message.parentId !== "") {
      obj.parentId = message.parentId;
    }
    if (message.trayId !== 0) {
      obj.trayId = Math.round(message.trayId);
    }
    if (message.trayDeviceId !== "") {
      obj.trayDeviceId = message.trayDeviceId;
    }
    if (message.bmcConfigs?.length) {
      obj.bmcConfigs = message.bmcConfigs.map((e) => BmcConfig.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<Node>, I>>(base?: I): Node {
    return Node.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<Node>, I>>(object: I): Node {
    const message = createBaseNode();
    message.id = object.id ?? "";
    message.name = object.name ?? "";
    message.description = object.description ?? "";
    message.labels = object.labels?.map((e) => e) || [];
    message.annotations = object.annotations?.map((e) => Annotation.fromPartial(e)) || [];
    message.enabled = object.enabled ?? false;
    message.metadata = (object.metadata !== undefined && object.metadata !== null)
      ? Metadata.fromPartial(object.metadata)
      : undefined;
    message.serialNumber = object.serialNumber ?? "";
    message.modelName = object.modelName ?? "";
    message.osType = object.osType ?? 0;
    message.nodeType = object.nodeType ?? 0;
    message.position = object.position ?? 0;
    message.fabricId = object.fabricId ?? "";
    message.deviceId = object.deviceId ?? "";
    message.location = object.location ?? "";
    message.roles = object.roles?.map((e) => e) || [];
    message.ports = object.ports?.map((e) => NetworkPort.fromPartial(e)) || [];
    message.connections = object.connections?.map((e) => PortConnection.fromPartial(e)) || [];
    message.managementPorts = object.managementPorts?.map((e) => ManagementPort.fromPartial(e)) || [];
    message.breakouts = object.breakouts?.map((e) => PortBreakout.fromPartial(e)) || [];
    message.psuAirflows = object.psuAirflows?.map((e) => PsuAirflow.fromPartial(e)) || [];
    message.hwSetId = object.hwSetId ?? "";
    message.groupId = object.groupId ?? "";
    message.hwSetNodePosition = object.hwSetNodePosition ?? 0;
    message.serverMgmtPorts = object.serverMgmtPorts?.map((e) => ServerMgmtPort.fromPartial(e)) || [];
    message.parentId = object.parentId ?? "";
    message.trayId = object.trayId ?? 0;
    message.trayDeviceId = object.trayDeviceId ?? "";
    message.bmcConfigs = object.bmcConfigs?.map((e) => BmcConfig.fromPartial(e)) || [];
    return message;
  },
};

function createBaseFabric(): Fabric {
  return {
    id: "",
    name: "",
    description: "",
    labels: [],
    annotations: [],
    enabled: false,
    metadata: undefined,
    candidateId: "0",
    topology: 0,
    level: 0,
    fabricType: 0,
    location: "",
    address: "",
    city: "",
    country: "",
    nodes: [],
    connections: [],
    sagMac: "",
    numCandidates: 0,
    unrecognized: [],
    design: undefined,
    internalLabels: [],
  };
}

export const Fabric: MessageFns<Fabric> = {
  encode(message: Fabric, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.name !== "") {
      writer.uint32(18).string(message.name);
    }
    if (message.description !== "") {
      writer.uint32(26).string(message.description);
    }
    for (const v of message.labels) {
      writer.uint32(34).string(v!);
    }
    for (const v of message.annotations) {
      Annotation.encode(v!, writer.uint32(42).fork()).join();
    }
    if (message.enabled !== false) {
      writer.uint32(48).bool(message.enabled);
    }
    if (message.metadata !== undefined) {
      Metadata.encode(message.metadata, writer.uint32(58).fork()).join();
    }
    if (message.candidateId !== "0") {
      writer.uint32(64).int64(message.candidateId);
    }
    if (message.topology !== 0) {
      writer.uint32(80).int32(message.topology);
    }
    if (message.level !== 0) {
      writer.uint32(88).int32(message.level);
    }
    if (message.fabricType !== 0) {
      writer.uint32(96).int32(message.fabricType);
    }
    if (message.location !== "") {
      writer.uint32(130).string(message.location);
    }
    if (message.address !== "") {
      writer.uint32(138).string(message.address);
    }
    if (message.city !== "") {
      writer.uint32(146).string(message.city);
    }
    if (message.country !== "") {
      writer.uint32(154).string(message.country);
    }
    for (const v of message.nodes) {
      Node.encode(v!, writer.uint32(162).fork()).join();
    }
    for (const v of message.connections) {
      PortConnection.encode(v!, writer.uint32(170).fork()).join();
    }
    if (message.sagMac !== "") {
      writer.uint32(178).string(message.sagMac);
    }
    if (message.numCandidates !== 0) {
      writer.uint32(184).uint32(message.numCandidates);
    }
    for (const v of message.unrecognized) {
      Node.encode(v!, writer.uint32(250).fork()).join();
    }
    if (message.design !== undefined) {
      FabricDesign.encode(message.design, writer.uint32(258).fork()).join();
    }
    for (const v of message.internalLabels) {
      writer.uint32(266).string(v!);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Fabric {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseFabric();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.description = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.labels.push(reader.string());
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.annotations.push(Annotation.decode(reader, reader.uint32()));
          continue;
        }
        case 6: {
          if (tag !== 48) {
            break;
          }

          message.enabled = reader.bool();
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.metadata = Metadata.decode(reader, reader.uint32());
          continue;
        }
        case 8: {
          if (tag !== 64) {
            break;
          }

          message.candidateId = reader.int64().toString();
          continue;
        }
        case 10: {
          if (tag !== 80) {
            break;
          }

          message.topology = reader.int32() as any;
          continue;
        }
        case 11: {
          if (tag !== 88) {
            break;
          }

          message.level = reader.int32() as any;
          continue;
        }
        case 12: {
          if (tag !== 96) {
            break;
          }

          message.fabricType = reader.int32() as any;
          continue;
        }
        case 16: {
          if (tag !== 130) {
            break;
          }

          message.location = reader.string();
          continue;
        }
        case 17: {
          if (tag !== 138) {
            break;
          }

          message.address = reader.string();
          continue;
        }
        case 18: {
          if (tag !== 146) {
            break;
          }

          message.city = reader.string();
          continue;
        }
        case 19: {
          if (tag !== 154) {
            break;
          }

          message.country = reader.string();
          continue;
        }
        case 20: {
          if (tag !== 162) {
            break;
          }

          message.nodes.push(Node.decode(reader, reader.uint32()));
          continue;
        }
        case 21: {
          if (tag !== 170) {
            break;
          }

          message.connections.push(PortConnection.decode(reader, reader.uint32()));
          continue;
        }
        case 22: {
          if (tag !== 178) {
            break;
          }

          message.sagMac = reader.string();
          continue;
        }
        case 23: {
          if (tag !== 184) {
            break;
          }

          message.numCandidates = reader.uint32();
          continue;
        }
        case 31: {
          if (tag !== 250) {
            break;
          }

          message.unrecognized.push(Node.decode(reader, reader.uint32()));
          continue;
        }
        case 32: {
          if (tag !== 258) {
            break;
          }

          message.design = FabricDesign.decode(reader, reader.uint32());
          continue;
        }
        case 33: {
          if (tag !== 266) {
            break;
          }

          message.internalLabels.push(reader.string());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): Fabric {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      name: isSet(object.name) ? globalThis.String(object.name) : "",
      description: isSet(object.description) ? globalThis.String(object.description) : "",
      labels: globalThis.Array.isArray(object?.labels) ? object.labels.map((e: any) => globalThis.String(e)) : [],
      annotations: globalThis.Array.isArray(object?.annotations)
        ? object.annotations.map((e: any) => Annotation.fromJSON(e))
        : [],
      enabled: isSet(object.enabled) ? globalThis.Boolean(object.enabled) : false,
      metadata: isSet(object.metadata) ? Metadata.fromJSON(object.metadata) : undefined,
      candidateId: isSet(object.candidateId) ? globalThis.String(object.candidateId) : "0",
      topology: isSet(object.topology) ? fabricTopologyFromJSON(object.topology) : 0,
      level: isSet(object.level) ? entitlementLevelFromJSON(object.level) : 0,
      fabricType: isSet(object.fabricType) ? fabricTypeFromJSON(object.fabricType) : 0,
      location: isSet(object.location) ? globalThis.String(object.location) : "",
      address: isSet(object.address) ? globalThis.String(object.address) : "",
      city: isSet(object.city) ? globalThis.String(object.city) : "",
      country: isSet(object.country) ? globalThis.String(object.country) : "",
      nodes: globalThis.Array.isArray(object?.nodes) ? object.nodes.map((e: any) => Node.fromJSON(e)) : [],
      connections: globalThis.Array.isArray(object?.connections)
        ? object.connections.map((e: any) => PortConnection.fromJSON(e))
        : [],
      sagMac: isSet(object.sagMac) ? globalThis.String(object.sagMac) : "",
      numCandidates: isSet(object.numCandidates) ? globalThis.Number(object.numCandidates) : 0,
      unrecognized: globalThis.Array.isArray(object?.unrecognized)
        ? object.unrecognized.map((e: any) => Node.fromJSON(e))
        : [],
      design: isSet(object.design) ? FabricDesign.fromJSON(object.design) : undefined,
      internalLabels: globalThis.Array.isArray(object?.internalLabels)
        ? object.internalLabels.map((e: any) => globalThis.String(e))
        : [],
    };
  },

  toJSON(message: Fabric): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.name !== "") {
      obj.name = message.name;
    }
    if (message.description !== "") {
      obj.description = message.description;
    }
    if (message.labels?.length) {
      obj.labels = message.labels;
    }
    if (message.annotations?.length) {
      obj.annotations = message.annotations.map((e) => Annotation.toJSON(e));
    }
    if (message.enabled !== false) {
      obj.enabled = message.enabled;
    }
    if (message.metadata !== undefined) {
      obj.metadata = Metadata.toJSON(message.metadata);
    }
    if (message.candidateId !== "0") {
      obj.candidateId = message.candidateId;
    }
    if (message.topology !== 0) {
      obj.topology = fabricTopologyToJSON(message.topology);
    }
    if (message.level !== 0) {
      obj.level = entitlementLevelToJSON(message.level);
    }
    if (message.fabricType !== 0) {
      obj.fabricType = fabricTypeToJSON(message.fabricType);
    }
    if (message.location !== "") {
      obj.location = message.location;
    }
    if (message.address !== "") {
      obj.address = message.address;
    }
    if (message.city !== "") {
      obj.city = message.city;
    }
    if (message.country !== "") {
      obj.country = message.country;
    }
    if (message.nodes?.length) {
      obj.nodes = message.nodes.map((e) => Node.toJSON(e));
    }
    if (message.connections?.length) {
      obj.connections = message.connections.map((e) => PortConnection.toJSON(e));
    }
    if (message.sagMac !== "") {
      obj.sagMac = message.sagMac;
    }
    if (message.numCandidates !== 0) {
      obj.numCandidates = Math.round(message.numCandidates);
    }
    if (message.unrecognized?.length) {
      obj.unrecognized = message.unrecognized.map((e) => Node.toJSON(e));
    }
    if (message.design !== undefined) {
      obj.design = FabricDesign.toJSON(message.design);
    }
    if (message.internalLabels?.length) {
      obj.internalLabels = message.internalLabels;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<Fabric>, I>>(base?: I): Fabric {
    return Fabric.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<Fabric>, I>>(object: I): Fabric {
    const message = createBaseFabric();
    message.id = object.id ?? "";
    message.name = object.name ?? "";
    message.description = object.description ?? "";
    message.labels = object.labels?.map((e) => e) || [];
    message.annotations = object.annotations?.map((e) => Annotation.fromPartial(e)) || [];
    message.enabled = object.enabled ?? false;
    message.metadata = (object.metadata !== undefined && object.metadata !== null)
      ? Metadata.fromPartial(object.metadata)
      : undefined;
    message.candidateId = object.candidateId ?? "0";
    message.topology = object.topology ?? 0;
    message.level = object.level ?? 0;
    message.fabricType = object.fabricType ?? 0;
    message.location = object.location ?? "";
    message.address = object.address ?? "";
    message.city = object.city ?? "";
    message.country = object.country ?? "";
    message.nodes = object.nodes?.map((e) => Node.fromPartial(e)) || [];
    message.connections = object.connections?.map((e) => PortConnection.fromPartial(e)) || [];
    message.sagMac = object.sagMac ?? "";
    message.numCandidates = object.numCandidates ?? 0;
    message.unrecognized = object.unrecognized?.map((e) => Node.fromPartial(e)) || [];
    message.design = (object.design !== undefined && object.design !== null)
      ? FabricDesign.fromPartial(object.design)
      : undefined;
    message.internalLabels = object.internalLabels?.map((e) => e) || [];
    return message;
  },
};

function createBaseStaticRoutes(): StaticRoutes {
  return {
    id: "",
    name: "",
    description: "",
    labels: [],
    annotations: [],
    enabled: false,
    metadata: undefined,
    fabricId: "",
    routes: [],
    vrfId: "",
  };
}

export const StaticRoutes: MessageFns<StaticRoutes> = {
  encode(message: StaticRoutes, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.name !== "") {
      writer.uint32(18).string(message.name);
    }
    if (message.description !== "") {
      writer.uint32(26).string(message.description);
    }
    for (const v of message.labels) {
      writer.uint32(34).string(v!);
    }
    for (const v of message.annotations) {
      Annotation.encode(v!, writer.uint32(42).fork()).join();
    }
    if (message.enabled !== false) {
      writer.uint32(48).bool(message.enabled);
    }
    if (message.metadata !== undefined) {
      Metadata.encode(message.metadata, writer.uint32(58).fork()).join();
    }
    if (message.fabricId !== "") {
      writer.uint32(74).string(message.fabricId);
    }
    for (const v of message.routes) {
      RouteInfo.encode(v!, writer.uint32(82).fork()).join();
    }
    if (message.vrfId !== "") {
      writer.uint32(90).string(message.vrfId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): StaticRoutes {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseStaticRoutes();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.description = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.labels.push(reader.string());
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.annotations.push(Annotation.decode(reader, reader.uint32()));
          continue;
        }
        case 6: {
          if (tag !== 48) {
            break;
          }

          message.enabled = reader.bool();
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.metadata = Metadata.decode(reader, reader.uint32());
          continue;
        }
        case 9: {
          if (tag !== 74) {
            break;
          }

          message.fabricId = reader.string();
          continue;
        }
        case 10: {
          if (tag !== 82) {
            break;
          }

          message.routes.push(RouteInfo.decode(reader, reader.uint32()));
          continue;
        }
        case 11: {
          if (tag !== 90) {
            break;
          }

          message.vrfId = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): StaticRoutes {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      name: isSet(object.name) ? globalThis.String(object.name) : "",
      description: isSet(object.description) ? globalThis.String(object.description) : "",
      labels: globalThis.Array.isArray(object?.labels) ? object.labels.map((e: any) => globalThis.String(e)) : [],
      annotations: globalThis.Array.isArray(object?.annotations)
        ? object.annotations.map((e: any) => Annotation.fromJSON(e))
        : [],
      enabled: isSet(object.enabled) ? globalThis.Boolean(object.enabled) : false,
      metadata: isSet(object.metadata) ? Metadata.fromJSON(object.metadata) : undefined,
      fabricId: isSet(object.fabricId) ? globalThis.String(object.fabricId) : "",
      routes: globalThis.Array.isArray(object?.routes) ? object.routes.map((e: any) => RouteInfo.fromJSON(e)) : [],
      vrfId: isSet(object.vrfId) ? globalThis.String(object.vrfId) : "",
    };
  },

  toJSON(message: StaticRoutes): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.name !== "") {
      obj.name = message.name;
    }
    if (message.description !== "") {
      obj.description = message.description;
    }
    if (message.labels?.length) {
      obj.labels = message.labels;
    }
    if (message.annotations?.length) {
      obj.annotations = message.annotations.map((e) => Annotation.toJSON(e));
    }
    if (message.enabled !== false) {
      obj.enabled = message.enabled;
    }
    if (message.metadata !== undefined) {
      obj.metadata = Metadata.toJSON(message.metadata);
    }
    if (message.fabricId !== "") {
      obj.fabricId = message.fabricId;
    }
    if (message.routes?.length) {
      obj.routes = message.routes.map((e) => RouteInfo.toJSON(e));
    }
    if (message.vrfId !== "") {
      obj.vrfId = message.vrfId;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<StaticRoutes>, I>>(base?: I): StaticRoutes {
    return StaticRoutes.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<StaticRoutes>, I>>(object: I): StaticRoutes {
    const message = createBaseStaticRoutes();
    message.id = object.id ?? "";
    message.name = object.name ?? "";
    message.description = object.description ?? "";
    message.labels = object.labels?.map((e) => e) || [];
    message.annotations = object.annotations?.map((e) => Annotation.fromPartial(e)) || [];
    message.enabled = object.enabled ?? false;
    message.metadata = (object.metadata !== undefined && object.metadata !== null)
      ? Metadata.fromPartial(object.metadata)
      : undefined;
    message.fabricId = object.fabricId ?? "";
    message.routes = object.routes?.map((e) => RouteInfo.fromPartial(e)) || [];
    message.vrfId = object.vrfId ?? "";
    return message;
  },
};

function createBaseVrf(): Vrf {
  return {
    id: "",
    name: "",
    description: "",
    labels: [],
    annotations: [],
    enabled: false,
    metadata: undefined,
    fabricId: "",
    interfaces: [],
    isDefault: false,
    vni: 0,
    asn: 0,
    ipv4Loopbacks: [],
    ipv6Loopbacks: [],
    routeTarget: "",
    loopback: "",
  };
}

export const Vrf: MessageFns<Vrf> = {
  encode(message: Vrf, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.name !== "") {
      writer.uint32(18).string(message.name);
    }
    if (message.description !== "") {
      writer.uint32(26).string(message.description);
    }
    for (const v of message.labels) {
      writer.uint32(34).string(v!);
    }
    for (const v of message.annotations) {
      Annotation.encode(v!, writer.uint32(42).fork()).join();
    }
    if (message.enabled !== false) {
      writer.uint32(48).bool(message.enabled);
    }
    if (message.metadata !== undefined) {
      Metadata.encode(message.metadata, writer.uint32(58).fork()).join();
    }
    if (message.fabricId !== "") {
      writer.uint32(74).string(message.fabricId);
    }
    for (const v of message.interfaces) {
      NetworkInterface.encode(v!, writer.uint32(82).fork()).join();
    }
    if (message.isDefault !== false) {
      writer.uint32(96).bool(message.isDefault);
    }
    if (message.vni !== 0) {
      writer.uint32(104).uint32(message.vni);
    }
    if (message.asn !== 0) {
      writer.uint32(112).uint32(message.asn);
    }
    for (const v of message.ipv4Loopbacks) {
      writer.uint32(146).string(v!);
    }
    for (const v of message.ipv6Loopbacks) {
      writer.uint32(154).string(v!);
    }
    if (message.routeTarget !== "") {
      writer.uint32(162).string(message.routeTarget);
    }
    if (message.loopback !== "") {
      writer.uint32(170).string(message.loopback);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Vrf {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseVrf();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.description = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.labels.push(reader.string());
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.annotations.push(Annotation.decode(reader, reader.uint32()));
          continue;
        }
        case 6: {
          if (tag !== 48) {
            break;
          }

          message.enabled = reader.bool();
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.metadata = Metadata.decode(reader, reader.uint32());
          continue;
        }
        case 9: {
          if (tag !== 74) {
            break;
          }

          message.fabricId = reader.string();
          continue;
        }
        case 10: {
          if (tag !== 82) {
            break;
          }

          message.interfaces.push(NetworkInterface.decode(reader, reader.uint32()));
          continue;
        }
        case 12: {
          if (tag !== 96) {
            break;
          }

          message.isDefault = reader.bool();
          continue;
        }
        case 13: {
          if (tag !== 104) {
            break;
          }

          message.vni = reader.uint32();
          continue;
        }
        case 14: {
          if (tag !== 112) {
            break;
          }

          message.asn = reader.uint32();
          continue;
        }
        case 18: {
          if (tag !== 146) {
            break;
          }

          message.ipv4Loopbacks.push(reader.string());
          continue;
        }
        case 19: {
          if (tag !== 154) {
            break;
          }

          message.ipv6Loopbacks.push(reader.string());
          continue;
        }
        case 20: {
          if (tag !== 162) {
            break;
          }

          message.routeTarget = reader.string();
          continue;
        }
        case 21: {
          if (tag !== 170) {
            break;
          }

          message.loopback = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): Vrf {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      name: isSet(object.name) ? globalThis.String(object.name) : "",
      description: isSet(object.description) ? globalThis.String(object.description) : "",
      labels: globalThis.Array.isArray(object?.labels) ? object.labels.map((e: any) => globalThis.String(e)) : [],
      annotations: globalThis.Array.isArray(object?.annotations)
        ? object.annotations.map((e: any) => Annotation.fromJSON(e))
        : [],
      enabled: isSet(object.enabled) ? globalThis.Boolean(object.enabled) : false,
      metadata: isSet(object.metadata) ? Metadata.fromJSON(object.metadata) : undefined,
      fabricId: isSet(object.fabricId) ? globalThis.String(object.fabricId) : "",
      interfaces: globalThis.Array.isArray(object?.interfaces)
        ? object.interfaces.map((e: any) => NetworkInterface.fromJSON(e))
        : [],
      isDefault: isSet(object.isDefault) ? globalThis.Boolean(object.isDefault) : false,
      vni: isSet(object.vni) ? globalThis.Number(object.vni) : 0,
      asn: isSet(object.asn) ? globalThis.Number(object.asn) : 0,
      ipv4Loopbacks: globalThis.Array.isArray(object?.ipv4Loopbacks)
        ? object.ipv4Loopbacks.map((e: any) => globalThis.String(e))
        : [],
      ipv6Loopbacks: globalThis.Array.isArray(object?.ipv6Loopbacks)
        ? object.ipv6Loopbacks.map((e: any) => globalThis.String(e))
        : [],
      routeTarget: isSet(object.routeTarget) ? globalThis.String(object.routeTarget) : "",
      loopback: isSet(object.loopback) ? globalThis.String(object.loopback) : "",
    };
  },

  toJSON(message: Vrf): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.name !== "") {
      obj.name = message.name;
    }
    if (message.description !== "") {
      obj.description = message.description;
    }
    if (message.labels?.length) {
      obj.labels = message.labels;
    }
    if (message.annotations?.length) {
      obj.annotations = message.annotations.map((e) => Annotation.toJSON(e));
    }
    if (message.enabled !== false) {
      obj.enabled = message.enabled;
    }
    if (message.metadata !== undefined) {
      obj.metadata = Metadata.toJSON(message.metadata);
    }
    if (message.fabricId !== "") {
      obj.fabricId = message.fabricId;
    }
    if (message.interfaces?.length) {
      obj.interfaces = message.interfaces.map((e) => NetworkInterface.toJSON(e));
    }
    if (message.isDefault !== false) {
      obj.isDefault = message.isDefault;
    }
    if (message.vni !== 0) {
      obj.vni = Math.round(message.vni);
    }
    if (message.asn !== 0) {
      obj.asn = Math.round(message.asn);
    }
    if (message.ipv4Loopbacks?.length) {
      obj.ipv4Loopbacks = message.ipv4Loopbacks;
    }
    if (message.ipv6Loopbacks?.length) {
      obj.ipv6Loopbacks = message.ipv6Loopbacks;
    }
    if (message.routeTarget !== "") {
      obj.routeTarget = message.routeTarget;
    }
    if (message.loopback !== "") {
      obj.loopback = message.loopback;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<Vrf>, I>>(base?: I): Vrf {
    return Vrf.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<Vrf>, I>>(object: I): Vrf {
    const message = createBaseVrf();
    message.id = object.id ?? "";
    message.name = object.name ?? "";
    message.description = object.description ?? "";
    message.labels = object.labels?.map((e) => e) || [];
    message.annotations = object.annotations?.map((e) => Annotation.fromPartial(e)) || [];
    message.enabled = object.enabled ?? false;
    message.metadata = (object.metadata !== undefined && object.metadata !== null)
      ? Metadata.fromPartial(object.metadata)
      : undefined;
    message.fabricId = object.fabricId ?? "";
    message.interfaces = object.interfaces?.map((e) => NetworkInterface.fromPartial(e)) || [];
    message.isDefault = object.isDefault ?? false;
    message.vni = object.vni ?? 0;
    message.asn = object.asn ?? 0;
    message.ipv4Loopbacks = object.ipv4Loopbacks?.map((e) => e) || [];
    message.ipv6Loopbacks = object.ipv6Loopbacks?.map((e) => e) || [];
    message.routeTarget = object.routeTarget ?? "";
    message.loopback = object.loopback ?? "";
    return message;
  },
};

function createBaseVlan(): Vlan {
  return {
    id: "",
    name: "",
    description: "",
    labels: [],
    annotations: [],
    enabled: false,
    metadata: undefined,
    fabricId: "",
    vlanId: 0,
    svis: [],
    members: [],
    vni: 0,
    vrfId: "",
  };
}

export const Vlan: MessageFns<Vlan> = {
  encode(message: Vlan, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.name !== "") {
      writer.uint32(18).string(message.name);
    }
    if (message.description !== "") {
      writer.uint32(26).string(message.description);
    }
    for (const v of message.labels) {
      writer.uint32(34).string(v!);
    }
    for (const v of message.annotations) {
      Annotation.encode(v!, writer.uint32(42).fork()).join();
    }
    if (message.enabled !== false) {
      writer.uint32(48).bool(message.enabled);
    }
    if (message.metadata !== undefined) {
      Metadata.encode(message.metadata, writer.uint32(58).fork()).join();
    }
    if (message.fabricId !== "") {
      writer.uint32(74).string(message.fabricId);
    }
    if (message.vlanId !== 0) {
      writer.uint32(80).uint32(message.vlanId);
    }
    for (const v of message.svis) {
      Svi.encode(v!, writer.uint32(90).fork()).join();
    }
    for (const v of message.members) {
      VlanMember.encode(v!, writer.uint32(98).fork()).join();
    }
    if (message.vni !== 0) {
      writer.uint32(152).uint32(message.vni);
    }
    if (message.vrfId !== "") {
      writer.uint32(162).string(message.vrfId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Vlan {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseVlan();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.description = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.labels.push(reader.string());
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.annotations.push(Annotation.decode(reader, reader.uint32()));
          continue;
        }
        case 6: {
          if (tag !== 48) {
            break;
          }

          message.enabled = reader.bool();
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.metadata = Metadata.decode(reader, reader.uint32());
          continue;
        }
        case 9: {
          if (tag !== 74) {
            break;
          }

          message.fabricId = reader.string();
          continue;
        }
        case 10: {
          if (tag !== 80) {
            break;
          }

          message.vlanId = reader.uint32();
          continue;
        }
        case 11: {
          if (tag !== 90) {
            break;
          }

          message.svis.push(Svi.decode(reader, reader.uint32()));
          continue;
        }
        case 12: {
          if (tag !== 98) {
            break;
          }

          message.members.push(VlanMember.decode(reader, reader.uint32()));
          continue;
        }
        case 19: {
          if (tag !== 152) {
            break;
          }

          message.vni = reader.uint32();
          continue;
        }
        case 20: {
          if (tag !== 162) {
            break;
          }

          message.vrfId = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): Vlan {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      name: isSet(object.name) ? globalThis.String(object.name) : "",
      description: isSet(object.description) ? globalThis.String(object.description) : "",
      labels: globalThis.Array.isArray(object?.labels) ? object.labels.map((e: any) => globalThis.String(e)) : [],
      annotations: globalThis.Array.isArray(object?.annotations)
        ? object.annotations.map((e: any) => Annotation.fromJSON(e))
        : [],
      enabled: isSet(object.enabled) ? globalThis.Boolean(object.enabled) : false,
      metadata: isSet(object.metadata) ? Metadata.fromJSON(object.metadata) : undefined,
      fabricId: isSet(object.fabricId) ? globalThis.String(object.fabricId) : "",
      vlanId: isSet(object.vlanId) ? globalThis.Number(object.vlanId) : 0,
      svis: globalThis.Array.isArray(object?.svis) ? object.svis.map((e: any) => Svi.fromJSON(e)) : [],
      members: globalThis.Array.isArray(object?.members) ? object.members.map((e: any) => VlanMember.fromJSON(e)) : [],
      vni: isSet(object.vni) ? globalThis.Number(object.vni) : 0,
      vrfId: isSet(object.vrfId) ? globalThis.String(object.vrfId) : "",
    };
  },

  toJSON(message: Vlan): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.name !== "") {
      obj.name = message.name;
    }
    if (message.description !== "") {
      obj.description = message.description;
    }
    if (message.labels?.length) {
      obj.labels = message.labels;
    }
    if (message.annotations?.length) {
      obj.annotations = message.annotations.map((e) => Annotation.toJSON(e));
    }
    if (message.enabled !== false) {
      obj.enabled = message.enabled;
    }
    if (message.metadata !== undefined) {
      obj.metadata = Metadata.toJSON(message.metadata);
    }
    if (message.fabricId !== "") {
      obj.fabricId = message.fabricId;
    }
    if (message.vlanId !== 0) {
      obj.vlanId = Math.round(message.vlanId);
    }
    if (message.svis?.length) {
      obj.svis = message.svis.map((e) => Svi.toJSON(e));
    }
    if (message.members?.length) {
      obj.members = message.members.map((e) => VlanMember.toJSON(e));
    }
    if (message.vni !== 0) {
      obj.vni = Math.round(message.vni);
    }
    if (message.vrfId !== "") {
      obj.vrfId = message.vrfId;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<Vlan>, I>>(base?: I): Vlan {
    return Vlan.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<Vlan>, I>>(object: I): Vlan {
    const message = createBaseVlan();
    message.id = object.id ?? "";
    message.name = object.name ?? "";
    message.description = object.description ?? "";
    message.labels = object.labels?.map((e) => e) || [];
    message.annotations = object.annotations?.map((e) => Annotation.fromPartial(e)) || [];
    message.enabled = object.enabled ?? false;
    message.metadata = (object.metadata !== undefined && object.metadata !== null)
      ? Metadata.fromPartial(object.metadata)
      : undefined;
    message.fabricId = object.fabricId ?? "";
    message.vlanId = object.vlanId ?? 0;
    message.svis = object.svis?.map((e) => Svi.fromPartial(e)) || [];
    message.members = object.members?.map((e) => VlanMember.fromPartial(e)) || [];
    message.vni = object.vni ?? 0;
    message.vrfId = object.vrfId ?? "";
    return message;
  },
};

function createBaseVni(): Vni {
  return {
    id: "",
    name: "",
    description: "",
    labels: [],
    annotations: [],
    enabled: false,
    metadata: undefined,
    fabricId: "",
    vlanId: 0,
    vni: 0,
    isDefault: false,
    mtu: 0,
    members: [],
    isL3: false,
    svis: [],
    vrfId: "",
    tag: 0,
  };
}

export const Vni: MessageFns<Vni> = {
  encode(message: Vni, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.name !== "") {
      writer.uint32(18).string(message.name);
    }
    if (message.description !== "") {
      writer.uint32(26).string(message.description);
    }
    for (const v of message.labels) {
      writer.uint32(34).string(v!);
    }
    for (const v of message.annotations) {
      Annotation.encode(v!, writer.uint32(42).fork()).join();
    }
    if (message.enabled !== false) {
      writer.uint32(48).bool(message.enabled);
    }
    if (message.metadata !== undefined) {
      Metadata.encode(message.metadata, writer.uint32(58).fork()).join();
    }
    if (message.fabricId !== "") {
      writer.uint32(66).string(message.fabricId);
    }
    if (message.vlanId !== 0) {
      writer.uint32(72).uint32(message.vlanId);
    }
    if (message.vni !== 0) {
      writer.uint32(80).uint32(message.vni);
    }
    if (message.isDefault !== false) {
      writer.uint32(88).bool(message.isDefault);
    }
    if (message.mtu !== 0) {
      writer.uint32(96).uint32(message.mtu);
    }
    for (const v of message.members) {
      VlanMember.encode(v!, writer.uint32(106).fork()).join();
    }
    if (message.isL3 !== false) {
      writer.uint32(112).bool(message.isL3);
    }
    for (const v of message.svis) {
      Svi.encode(v!, writer.uint32(122).fork()).join();
    }
    if (message.vrfId !== "") {
      writer.uint32(130).string(message.vrfId);
    }
    if (message.tag !== 0) {
      writer.uint32(136).int32(message.tag);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Vni {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseVni();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.description = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.labels.push(reader.string());
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.annotations.push(Annotation.decode(reader, reader.uint32()));
          continue;
        }
        case 6: {
          if (tag !== 48) {
            break;
          }

          message.enabled = reader.bool();
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.metadata = Metadata.decode(reader, reader.uint32());
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.fabricId = reader.string();
          continue;
        }
        case 9: {
          if (tag !== 72) {
            break;
          }

          message.vlanId = reader.uint32();
          continue;
        }
        case 10: {
          if (tag !== 80) {
            break;
          }

          message.vni = reader.uint32();
          continue;
        }
        case 11: {
          if (tag !== 88) {
            break;
          }

          message.isDefault = reader.bool();
          continue;
        }
        case 12: {
          if (tag !== 96) {
            break;
          }

          message.mtu = reader.uint32();
          continue;
        }
        case 13: {
          if (tag !== 106) {
            break;
          }

          message.members.push(VlanMember.decode(reader, reader.uint32()));
          continue;
        }
        case 14: {
          if (tag !== 112) {
            break;
          }

          message.isL3 = reader.bool();
          continue;
        }
        case 15: {
          if (tag !== 122) {
            break;
          }

          message.svis.push(Svi.decode(reader, reader.uint32()));
          continue;
        }
        case 16: {
          if (tag !== 130) {
            break;
          }

          message.vrfId = reader.string();
          continue;
        }
        case 17: {
          if (tag !== 136) {
            break;
          }

          message.tag = reader.int32() as any;
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): Vni {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      name: isSet(object.name) ? globalThis.String(object.name) : "",
      description: isSet(object.description) ? globalThis.String(object.description) : "",
      labels: globalThis.Array.isArray(object?.labels) ? object.labels.map((e: any) => globalThis.String(e)) : [],
      annotations: globalThis.Array.isArray(object?.annotations)
        ? object.annotations.map((e: any) => Annotation.fromJSON(e))
        : [],
      enabled: isSet(object.enabled) ? globalThis.Boolean(object.enabled) : false,
      metadata: isSet(object.metadata) ? Metadata.fromJSON(object.metadata) : undefined,
      fabricId: isSet(object.fabricId) ? globalThis.String(object.fabricId) : "",
      vlanId: isSet(object.vlanId) ? globalThis.Number(object.vlanId) : 0,
      vni: isSet(object.vni) ? globalThis.Number(object.vni) : 0,
      isDefault: isSet(object.isDefault) ? globalThis.Boolean(object.isDefault) : false,
      mtu: isSet(object.mtu) ? globalThis.Number(object.mtu) : 0,
      members: globalThis.Array.isArray(object?.members) ? object.members.map((e: any) => VlanMember.fromJSON(e)) : [],
      isL3: isSet(object.isL3) ? globalThis.Boolean(object.isL3) : false,
      svis: globalThis.Array.isArray(object?.svis) ? object.svis.map((e: any) => Svi.fromJSON(e)) : [],
      vrfId: isSet(object.vrfId) ? globalThis.String(object.vrfId) : "",
      tag: isSet(object.tag) ? routeTagFromJSON(object.tag) : 0,
    };
  },

  toJSON(message: Vni): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.name !== "") {
      obj.name = message.name;
    }
    if (message.description !== "") {
      obj.description = message.description;
    }
    if (message.labels?.length) {
      obj.labels = message.labels;
    }
    if (message.annotations?.length) {
      obj.annotations = message.annotations.map((e) => Annotation.toJSON(e));
    }
    if (message.enabled !== false) {
      obj.enabled = message.enabled;
    }
    if (message.metadata !== undefined) {
      obj.metadata = Metadata.toJSON(message.metadata);
    }
    if (message.fabricId !== "") {
      obj.fabricId = message.fabricId;
    }
    if (message.vlanId !== 0) {
      obj.vlanId = Math.round(message.vlanId);
    }
    if (message.vni !== 0) {
      obj.vni = Math.round(message.vni);
    }
    if (message.isDefault !== false) {
      obj.isDefault = message.isDefault;
    }
    if (message.mtu !== 0) {
      obj.mtu = Math.round(message.mtu);
    }
    if (message.members?.length) {
      obj.members = message.members.map((e) => VlanMember.toJSON(e));
    }
    if (message.isL3 !== false) {
      obj.isL3 = message.isL3;
    }
    if (message.svis?.length) {
      obj.svis = message.svis.map((e) => Svi.toJSON(e));
    }
    if (message.vrfId !== "") {
      obj.vrfId = message.vrfId;
    }
    if (message.tag !== 0) {
      obj.tag = routeTagToJSON(message.tag);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<Vni>, I>>(base?: I): Vni {
    return Vni.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<Vni>, I>>(object: I): Vni {
    const message = createBaseVni();
    message.id = object.id ?? "";
    message.name = object.name ?? "";
    message.description = object.description ?? "";
    message.labels = object.labels?.map((e) => e) || [];
    message.annotations = object.annotations?.map((e) => Annotation.fromPartial(e)) || [];
    message.enabled = object.enabled ?? false;
    message.metadata = (object.metadata !== undefined && object.metadata !== null)
      ? Metadata.fromPartial(object.metadata)
      : undefined;
    message.fabricId = object.fabricId ?? "";
    message.vlanId = object.vlanId ?? 0;
    message.vni = object.vni ?? 0;
    message.isDefault = object.isDefault ?? false;
    message.mtu = object.mtu ?? 0;
    message.members = object.members?.map((e) => VlanMember.fromPartial(e)) || [];
    message.isL3 = object.isL3 ?? false;
    message.svis = object.svis?.map((e) => Svi.fromPartial(e)) || [];
    message.vrfId = object.vrfId ?? "";
    message.tag = object.tag ?? 0;
    return message;
  },
};

function createBaseLoopback(): Loopback {
  return {
    id: "",
    name: "",
    description: "",
    labels: [],
    annotations: [],
    enabled: false,
    metadata: undefined,
    fabricId: "",
    nodeId: "",
    ipv4Address: "",
    ipv6Address: "",
    tag: 0,
    vrfId: "",
    autoCreated: false,
  };
}

export const Loopback: MessageFns<Loopback> = {
  encode(message: Loopback, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.name !== "") {
      writer.uint32(18).string(message.name);
    }
    if (message.description !== "") {
      writer.uint32(26).string(message.description);
    }
    for (const v of message.labels) {
      writer.uint32(34).string(v!);
    }
    for (const v of message.annotations) {
      Annotation.encode(v!, writer.uint32(42).fork()).join();
    }
    if (message.enabled !== false) {
      writer.uint32(48).bool(message.enabled);
    }
    if (message.metadata !== undefined) {
      Metadata.encode(message.metadata, writer.uint32(58).fork()).join();
    }
    if (message.fabricId !== "") {
      writer.uint32(74).string(message.fabricId);
    }
    if (message.nodeId !== "") {
      writer.uint32(82).string(message.nodeId);
    }
    if (message.ipv4Address !== "") {
      writer.uint32(90).string(message.ipv4Address);
    }
    if (message.ipv6Address !== "") {
      writer.uint32(98).string(message.ipv6Address);
    }
    if (message.tag !== 0) {
      writer.uint32(104).int32(message.tag);
    }
    if (message.vrfId !== "") {
      writer.uint32(162).string(message.vrfId);
    }
    if (message.autoCreated !== false) {
      writer.uint32(168).bool(message.autoCreated);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Loopback {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseLoopback();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.description = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.labels.push(reader.string());
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.annotations.push(Annotation.decode(reader, reader.uint32()));
          continue;
        }
        case 6: {
          if (tag !== 48) {
            break;
          }

          message.enabled = reader.bool();
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.metadata = Metadata.decode(reader, reader.uint32());
          continue;
        }
        case 9: {
          if (tag !== 74) {
            break;
          }

          message.fabricId = reader.string();
          continue;
        }
        case 10: {
          if (tag !== 82) {
            break;
          }

          message.nodeId = reader.string();
          continue;
        }
        case 11: {
          if (tag !== 90) {
            break;
          }

          message.ipv4Address = reader.string();
          continue;
        }
        case 12: {
          if (tag !== 98) {
            break;
          }

          message.ipv6Address = reader.string();
          continue;
        }
        case 13: {
          if (tag !== 104) {
            break;
          }

          message.tag = reader.int32() as any;
          continue;
        }
        case 20: {
          if (tag !== 162) {
            break;
          }

          message.vrfId = reader.string();
          continue;
        }
        case 21: {
          if (tag !== 168) {
            break;
          }

          message.autoCreated = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): Loopback {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      name: isSet(object.name) ? globalThis.String(object.name) : "",
      description: isSet(object.description) ? globalThis.String(object.description) : "",
      labels: globalThis.Array.isArray(object?.labels) ? object.labels.map((e: any) => globalThis.String(e)) : [],
      annotations: globalThis.Array.isArray(object?.annotations)
        ? object.annotations.map((e: any) => Annotation.fromJSON(e))
        : [],
      enabled: isSet(object.enabled) ? globalThis.Boolean(object.enabled) : false,
      metadata: isSet(object.metadata) ? Metadata.fromJSON(object.metadata) : undefined,
      fabricId: isSet(object.fabricId) ? globalThis.String(object.fabricId) : "",
      nodeId: isSet(object.nodeId) ? globalThis.String(object.nodeId) : "",
      ipv4Address: isSet(object.ipv4Address) ? globalThis.String(object.ipv4Address) : "",
      ipv6Address: isSet(object.ipv6Address) ? globalThis.String(object.ipv6Address) : "",
      tag: isSet(object.tag) ? routeTagFromJSON(object.tag) : 0,
      vrfId: isSet(object.vrfId) ? globalThis.String(object.vrfId) : "",
      autoCreated: isSet(object.autoCreated) ? globalThis.Boolean(object.autoCreated) : false,
    };
  },

  toJSON(message: Loopback): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.name !== "") {
      obj.name = message.name;
    }
    if (message.description !== "") {
      obj.description = message.description;
    }
    if (message.labels?.length) {
      obj.labels = message.labels;
    }
    if (message.annotations?.length) {
      obj.annotations = message.annotations.map((e) => Annotation.toJSON(e));
    }
    if (message.enabled !== false) {
      obj.enabled = message.enabled;
    }
    if (message.metadata !== undefined) {
      obj.metadata = Metadata.toJSON(message.metadata);
    }
    if (message.fabricId !== "") {
      obj.fabricId = message.fabricId;
    }
    if (message.nodeId !== "") {
      obj.nodeId = message.nodeId;
    }
    if (message.ipv4Address !== "") {
      obj.ipv4Address = message.ipv4Address;
    }
    if (message.ipv6Address !== "") {
      obj.ipv6Address = message.ipv6Address;
    }
    if (message.tag !== 0) {
      obj.tag = routeTagToJSON(message.tag);
    }
    if (message.vrfId !== "") {
      obj.vrfId = message.vrfId;
    }
    if (message.autoCreated !== false) {
      obj.autoCreated = message.autoCreated;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<Loopback>, I>>(base?: I): Loopback {
    return Loopback.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<Loopback>, I>>(object: I): Loopback {
    const message = createBaseLoopback();
    message.id = object.id ?? "";
    message.name = object.name ?? "";
    message.description = object.description ?? "";
    message.labels = object.labels?.map((e) => e) || [];
    message.annotations = object.annotations?.map((e) => Annotation.fromPartial(e)) || [];
    message.enabled = object.enabled ?? false;
    message.metadata = (object.metadata !== undefined && object.metadata !== null)
      ? Metadata.fromPartial(object.metadata)
      : undefined;
    message.fabricId = object.fabricId ?? "";
    message.nodeId = object.nodeId ?? "";
    message.ipv4Address = object.ipv4Address ?? "";
    message.ipv6Address = object.ipv6Address ?? "";
    message.tag = object.tag ?? 0;
    message.vrfId = object.vrfId ?? "";
    message.autoCreated = object.autoCreated ?? false;
    return message;
  },
};

function createBaseDhcpRelay(): DhcpRelay {
  return {
    id: "",
    name: "",
    description: "",
    labels: [],
    annotations: [],
    enabled: false,
    metadata: undefined,
    fabricId: "",
    vrfId: "",
    ipv4Addresses: [],
    ipv6Addresses: [],
    vnis: [],
  };
}

export const DhcpRelay: MessageFns<DhcpRelay> = {
  encode(message: DhcpRelay, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.name !== "") {
      writer.uint32(18).string(message.name);
    }
    if (message.description !== "") {
      writer.uint32(26).string(message.description);
    }
    for (const v of message.labels) {
      writer.uint32(34).string(v!);
    }
    for (const v of message.annotations) {
      Annotation.encode(v!, writer.uint32(42).fork()).join();
    }
    if (message.enabled !== false) {
      writer.uint32(48).bool(message.enabled);
    }
    if (message.metadata !== undefined) {
      Metadata.encode(message.metadata, writer.uint32(58).fork()).join();
    }
    if (message.fabricId !== "") {
      writer.uint32(74).string(message.fabricId);
    }
    if (message.vrfId !== "") {
      writer.uint32(82).string(message.vrfId);
    }
    for (const v of message.ipv4Addresses) {
      writer.uint32(122).string(v!);
    }
    for (const v of message.ipv6Addresses) {
      writer.uint32(130).string(v!);
    }
    for (const v of message.vnis) {
      VniDhcp.encode(v!, writer.uint32(162).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DhcpRelay {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDhcpRelay();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.description = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.labels.push(reader.string());
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.annotations.push(Annotation.decode(reader, reader.uint32()));
          continue;
        }
        case 6: {
          if (tag !== 48) {
            break;
          }

          message.enabled = reader.bool();
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.metadata = Metadata.decode(reader, reader.uint32());
          continue;
        }
        case 9: {
          if (tag !== 74) {
            break;
          }

          message.fabricId = reader.string();
          continue;
        }
        case 10: {
          if (tag !== 82) {
            break;
          }

          message.vrfId = reader.string();
          continue;
        }
        case 15: {
          if (tag !== 122) {
            break;
          }

          message.ipv4Addresses.push(reader.string());
          continue;
        }
        case 16: {
          if (tag !== 130) {
            break;
          }

          message.ipv6Addresses.push(reader.string());
          continue;
        }
        case 20: {
          if (tag !== 162) {
            break;
          }

          message.vnis.push(VniDhcp.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): DhcpRelay {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      name: isSet(object.name) ? globalThis.String(object.name) : "",
      description: isSet(object.description) ? globalThis.String(object.description) : "",
      labels: globalThis.Array.isArray(object?.labels) ? object.labels.map((e: any) => globalThis.String(e)) : [],
      annotations: globalThis.Array.isArray(object?.annotations)
        ? object.annotations.map((e: any) => Annotation.fromJSON(e))
        : [],
      enabled: isSet(object.enabled) ? globalThis.Boolean(object.enabled) : false,
      metadata: isSet(object.metadata) ? Metadata.fromJSON(object.metadata) : undefined,
      fabricId: isSet(object.fabricId) ? globalThis.String(object.fabricId) : "",
      vrfId: isSet(object.vrfId) ? globalThis.String(object.vrfId) : "",
      ipv4Addresses: globalThis.Array.isArray(object?.ipv4Addresses)
        ? object.ipv4Addresses.map((e: any) => globalThis.String(e))
        : [],
      ipv6Addresses: globalThis.Array.isArray(object?.ipv6Addresses)
        ? object.ipv6Addresses.map((e: any) => globalThis.String(e))
        : [],
      vnis: globalThis.Array.isArray(object?.vnis) ? object.vnis.map((e: any) => VniDhcp.fromJSON(e)) : [],
    };
  },

  toJSON(message: DhcpRelay): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.name !== "") {
      obj.name = message.name;
    }
    if (message.description !== "") {
      obj.description = message.description;
    }
    if (message.labels?.length) {
      obj.labels = message.labels;
    }
    if (message.annotations?.length) {
      obj.annotations = message.annotations.map((e) => Annotation.toJSON(e));
    }
    if (message.enabled !== false) {
      obj.enabled = message.enabled;
    }
    if (message.metadata !== undefined) {
      obj.metadata = Metadata.toJSON(message.metadata);
    }
    if (message.fabricId !== "") {
      obj.fabricId = message.fabricId;
    }
    if (message.vrfId !== "") {
      obj.vrfId = message.vrfId;
    }
    if (message.ipv4Addresses?.length) {
      obj.ipv4Addresses = message.ipv4Addresses;
    }
    if (message.ipv6Addresses?.length) {
      obj.ipv6Addresses = message.ipv6Addresses;
    }
    if (message.vnis?.length) {
      obj.vnis = message.vnis.map((e) => VniDhcp.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<DhcpRelay>, I>>(base?: I): DhcpRelay {
    return DhcpRelay.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<DhcpRelay>, I>>(object: I): DhcpRelay {
    const message = createBaseDhcpRelay();
    message.id = object.id ?? "";
    message.name = object.name ?? "";
    message.description = object.description ?? "";
    message.labels = object.labels?.map((e) => e) || [];
    message.annotations = object.annotations?.map((e) => Annotation.fromPartial(e)) || [];
    message.enabled = object.enabled ?? false;
    message.metadata = (object.metadata !== undefined && object.metadata !== null)
      ? Metadata.fromPartial(object.metadata)
      : undefined;
    message.fabricId = object.fabricId ?? "";
    message.vrfId = object.vrfId ?? "";
    message.ipv4Addresses = object.ipv4Addresses?.map((e) => e) || [];
    message.ipv6Addresses = object.ipv6Addresses?.map((e) => e) || [];
    message.vnis = object.vnis?.map((e) => VniDhcp.fromPartial(e)) || [];
    return message;
  },
};

function createBasePortBreakout(): PortBreakout {
  return {
    id: "",
    name: "",
    description: "",
    labels: [],
    annotations: [],
    enabled: false,
    metadata: undefined,
    fabricId: "",
    nodeId: "",
    pluggable: "",
    mode: "",
    ports: [],
    breakouts: [],
  };
}

export const PortBreakout: MessageFns<PortBreakout> = {
  encode(message: PortBreakout, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.name !== "") {
      writer.uint32(18).string(message.name);
    }
    if (message.description !== "") {
      writer.uint32(26).string(message.description);
    }
    for (const v of message.labels) {
      writer.uint32(34).string(v!);
    }
    for (const v of message.annotations) {
      Annotation.encode(v!, writer.uint32(42).fork()).join();
    }
    if (message.enabled !== false) {
      writer.uint32(48).bool(message.enabled);
    }
    if (message.metadata !== undefined) {
      Metadata.encode(message.metadata, writer.uint32(58).fork()).join();
    }
    if (message.fabricId !== "") {
      writer.uint32(74).string(message.fabricId);
    }
    if (message.nodeId !== "") {
      writer.uint32(82).string(message.nodeId);
    }
    if (message.pluggable !== "") {
      writer.uint32(98).string(message.pluggable);
    }
    if (message.mode !== "") {
      writer.uint32(106).string(message.mode);
    }
    for (const v of message.ports) {
      writer.uint32(114).string(v!);
    }
    for (const v of message.breakouts) {
      writer.uint32(162).string(v!);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): PortBreakout {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePortBreakout();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.description = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.labels.push(reader.string());
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.annotations.push(Annotation.decode(reader, reader.uint32()));
          continue;
        }
        case 6: {
          if (tag !== 48) {
            break;
          }

          message.enabled = reader.bool();
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.metadata = Metadata.decode(reader, reader.uint32());
          continue;
        }
        case 9: {
          if (tag !== 74) {
            break;
          }

          message.fabricId = reader.string();
          continue;
        }
        case 10: {
          if (tag !== 82) {
            break;
          }

          message.nodeId = reader.string();
          continue;
        }
        case 12: {
          if (tag !== 98) {
            break;
          }

          message.pluggable = reader.string();
          continue;
        }
        case 13: {
          if (tag !== 106) {
            break;
          }

          message.mode = reader.string();
          continue;
        }
        case 14: {
          if (tag !== 114) {
            break;
          }

          message.ports.push(reader.string());
          continue;
        }
        case 20: {
          if (tag !== 162) {
            break;
          }

          message.breakouts.push(reader.string());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): PortBreakout {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      name: isSet(object.name) ? globalThis.String(object.name) : "",
      description: isSet(object.description) ? globalThis.String(object.description) : "",
      labels: globalThis.Array.isArray(object?.labels) ? object.labels.map((e: any) => globalThis.String(e)) : [],
      annotations: globalThis.Array.isArray(object?.annotations)
        ? object.annotations.map((e: any) => Annotation.fromJSON(e))
        : [],
      enabled: isSet(object.enabled) ? globalThis.Boolean(object.enabled) : false,
      metadata: isSet(object.metadata) ? Metadata.fromJSON(object.metadata) : undefined,
      fabricId: isSet(object.fabricId) ? globalThis.String(object.fabricId) : "",
      nodeId: isSet(object.nodeId) ? globalThis.String(object.nodeId) : "",
      pluggable: isSet(object.pluggable) ? globalThis.String(object.pluggable) : "",
      mode: isSet(object.mode) ? globalThis.String(object.mode) : "",
      ports: globalThis.Array.isArray(object?.ports) ? object.ports.map((e: any) => globalThis.String(e)) : [],
      breakouts: globalThis.Array.isArray(object?.breakouts)
        ? object.breakouts.map((e: any) => globalThis.String(e))
        : [],
    };
  },

  toJSON(message: PortBreakout): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.name !== "") {
      obj.name = message.name;
    }
    if (message.description !== "") {
      obj.description = message.description;
    }
    if (message.labels?.length) {
      obj.labels = message.labels;
    }
    if (message.annotations?.length) {
      obj.annotations = message.annotations.map((e) => Annotation.toJSON(e));
    }
    if (message.enabled !== false) {
      obj.enabled = message.enabled;
    }
    if (message.metadata !== undefined) {
      obj.metadata = Metadata.toJSON(message.metadata);
    }
    if (message.fabricId !== "") {
      obj.fabricId = message.fabricId;
    }
    if (message.nodeId !== "") {
      obj.nodeId = message.nodeId;
    }
    if (message.pluggable !== "") {
      obj.pluggable = message.pluggable;
    }
    if (message.mode !== "") {
      obj.mode = message.mode;
    }
    if (message.ports?.length) {
      obj.ports = message.ports;
    }
    if (message.breakouts?.length) {
      obj.breakouts = message.breakouts;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<PortBreakout>, I>>(base?: I): PortBreakout {
    return PortBreakout.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<PortBreakout>, I>>(object: I): PortBreakout {
    const message = createBasePortBreakout();
    message.id = object.id ?? "";
    message.name = object.name ?? "";
    message.description = object.description ?? "";
    message.labels = object.labels?.map((e) => e) || [];
    message.annotations = object.annotations?.map((e) => Annotation.fromPartial(e)) || [];
    message.enabled = object.enabled ?? false;
    message.metadata = (object.metadata !== undefined && object.metadata !== null)
      ? Metadata.fromPartial(object.metadata)
      : undefined;
    message.fabricId = object.fabricId ?? "";
    message.nodeId = object.nodeId ?? "";
    message.pluggable = object.pluggable ?? "";
    message.mode = object.mode ?? "";
    message.ports = object.ports?.map((e) => e) || [];
    message.breakouts = object.breakouts?.map((e) => e) || [];
    return message;
  },
};

function createBaseSlotMapConfiguration(): SlotMapConfiguration {
  return { gpuSlot: 0, nicSlots: [] };
}

export const SlotMapConfiguration: MessageFns<SlotMapConfiguration> = {
  encode(message: SlotMapConfiguration, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.gpuSlot !== 0) {
      writer.uint32(8).uint32(message.gpuSlot);
    }
    writer.uint32(18).fork();
    for (const v of message.nicSlots) {
      writer.int32(v);
    }
    writer.join();
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SlotMapConfiguration {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSlotMapConfiguration();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.gpuSlot = reader.uint32();
          continue;
        }
        case 2: {
          if (tag === 16) {
            message.nicSlots.push(reader.int32());

            continue;
          }

          if (tag === 18) {
            const end2 = reader.uint32() + reader.pos;
            while (reader.pos < end2) {
              message.nicSlots.push(reader.int32());
            }

            continue;
          }

          break;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SlotMapConfiguration {
    return {
      gpuSlot: isSet(object.gpuSlot) ? globalThis.Number(object.gpuSlot) : 0,
      nicSlots: globalThis.Array.isArray(object?.nicSlots) ? object.nicSlots.map((e: any) => globalThis.Number(e)) : [],
    };
  },

  toJSON(message: SlotMapConfiguration): unknown {
    const obj: any = {};
    if (message.gpuSlot !== 0) {
      obj.gpuSlot = Math.round(message.gpuSlot);
    }
    if (message.nicSlots?.length) {
      obj.nicSlots = message.nicSlots.map((e) => Math.round(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<SlotMapConfiguration>, I>>(base?: I): SlotMapConfiguration {
    return SlotMapConfiguration.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SlotMapConfiguration>, I>>(object: I): SlotMapConfiguration {
    const message = createBaseSlotMapConfiguration();
    message.gpuSlot = object.gpuSlot ?? 0;
    message.nicSlots = object.nicSlots?.map((e) => e) || [];
    return message;
  },
};

function createBaseGpuMode(): GpuMode {
  return { numGpus: 0, enabled: false, recommendedSlots: [] };
}

export const GpuMode: MessageFns<GpuMode> = {
  encode(message: GpuMode, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.numGpus !== 0) {
      writer.uint32(8).uint32(message.numGpus);
    }
    if (message.enabled !== false) {
      writer.uint32(16).bool(message.enabled);
    }
    for (const v of message.recommendedSlots) {
      writer.uint32(26).string(v!);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GpuMode {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGpuMode();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.numGpus = reader.uint32();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.enabled = reader.bool();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.recommendedSlots.push(reader.string());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GpuMode {
    return {
      numGpus: isSet(object.numGpus) ? globalThis.Number(object.numGpus) : 0,
      enabled: isSet(object.enabled) ? globalThis.Boolean(object.enabled) : false,
      recommendedSlots: globalThis.Array.isArray(object?.recommendedSlots)
        ? object.recommendedSlots.map((e: any) => globalThis.String(e))
        : [],
    };
  },

  toJSON(message: GpuMode): unknown {
    const obj: any = {};
    if (message.numGpus !== 0) {
      obj.numGpus = Math.round(message.numGpus);
    }
    if (message.enabled !== false) {
      obj.enabled = message.enabled;
    }
    if (message.recommendedSlots?.length) {
      obj.recommendedSlots = message.recommendedSlots;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GpuMode>, I>>(base?: I): GpuMode {
    return GpuMode.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GpuMode>, I>>(object: I): GpuMode {
    const message = createBaseGpuMode();
    message.numGpus = object.numGpus ?? 0;
    message.enabled = object.enabled ?? false;
    message.recommendedSlots = object.recommendedSlots?.map((e) => e) || [];
    return message;
  },
};

function createBasePortSummaryInfo(): PortSummaryInfo {
  return { portSpeed: "", pluggable: "", numPorts: 0 };
}

export const PortSummaryInfo: MessageFns<PortSummaryInfo> = {
  encode(message: PortSummaryInfo, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.portSpeed !== "") {
      writer.uint32(10).string(message.portSpeed);
    }
    if (message.pluggable !== "") {
      writer.uint32(18).string(message.pluggable);
    }
    if (message.numPorts !== 0) {
      writer.uint32(24).uint32(message.numPorts);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): PortSummaryInfo {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePortSummaryInfo();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.portSpeed = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.pluggable = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.numPorts = reader.uint32();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): PortSummaryInfo {
    return {
      portSpeed: isSet(object.portSpeed) ? globalThis.String(object.portSpeed) : "",
      pluggable: isSet(object.pluggable) ? globalThis.String(object.pluggable) : "",
      numPorts: isSet(object.numPorts) ? globalThis.Number(object.numPorts) : 0,
    };
  },

  toJSON(message: PortSummaryInfo): unknown {
    const obj: any = {};
    if (message.portSpeed !== "") {
      obj.portSpeed = message.portSpeed;
    }
    if (message.pluggable !== "") {
      obj.pluggable = message.pluggable;
    }
    if (message.numPorts !== 0) {
      obj.numPorts = Math.round(message.numPorts);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<PortSummaryInfo>, I>>(base?: I): PortSummaryInfo {
    return PortSummaryInfo.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<PortSummaryInfo>, I>>(object: I): PortSummaryInfo {
    const message = createBasePortSummaryInfo();
    message.portSpeed = object.portSpeed ?? "";
    message.pluggable = object.pluggable ?? "";
    message.numPorts = object.numPorts ?? 0;
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

export interface MessageFns<T> {
  encode(message: T, writer?: BinaryWriter): BinaryWriter;
  decode(input: BinaryReader | Uint8Array, length?: number): T;
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
  create<I extends Exact<DeepPartial<T>, I>>(base?: I): T;
  fromPartial<I extends Exact<DeepPartial<T>, I>>(object: I): T;
}
